import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  AfterViewInit
} from "@angular/core";
import { firstValueFrom, merge, Subscription } from "rxjs";
import { debounceTime, startWith } from "rxjs/operators";
import {
  NgbCalendar,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  CustomDatepickerI18n,
  I18n,
} from "src/app/util/ngbd-datepicker-i18n/ngbd-datepicker-i18n.component";
import { DateformatService } from "../../util/dateformat.service";
import { RequirementService } from "@services/requirement.service";
import { DateAdapter } from "@app/trackvision/util/dateadapter.service";
import { correctRutValidator } from '../directive/correct-rut.directive';
import { forbiddenNameValidator } from '../directive/forbidden-name.directive';
import { validEmailValidator } from '../directive/valid-email.directive';
import { ComunaService } from '@app/services/services/comuna.service';

import { CustomfieldsService } from "@services/customfields.service";
import { ConfirmActionModalComponent } from "../components/confirm-action-modal/confirm-action-modal.component";
import { AreaService } from "@services/services/area.services";
import { Type20Service } from "@services/services/type20.service";
import { Type22Service } from "@services/services/type22.service";
import moment from "moment";
import {
  collectMergedRulesFromFields,
  collectTriggerFieldNames,
  executeComputedRules,
  findFieldByExactFieldName,
} from "./computed-rules.helper";
import { normalizeMontoForStorage } from "../utils/monto-format.util";
import { shouldApplyDefaultValue } from "./customfields-default.util";
import {
  isCheckedValue,
  isSourceIndex,
  optionChildName,
  readCopyFromGroup,
  resolveTargetOptionName,
} from "./copy-from-group.helper";
import { type53FileValidators } from "../custom-fields-switch/type53-docs.util";
import {
  extractType52Id,
  parseType52StoredValue,
  serializeType52ForStorage,
} from "../utils/type52-stored-value.util";





@Component({
    selector: "app-customfields",
    templateUrl: "./customfields.component.html",
    styleUrls: ["./customfields.component.scss"],
    providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: DateformatService },
        { provide: NgbDateAdapter, useClass: DateAdapter },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomfieldsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  //#region Variables
  @Input() fields = [];
  @Input() customfieldsAlls = [];
  @Input() groupId = null;
  @Input() reqId;
  @Input() context = "creation";
  @Input() terminarCausa: boolean = false;
  @Input() edit: boolean = false;
  @Input() flagActionLog: boolean = false;
  @Input() resultCustomfieldsSubGrop: any = [];
  @Input() isSubGrupo: boolean = false;

  @Output() customfieldsValues = new EventEmitter<any>();

  /**
   * Cuando el tipo 53 vive en otra instancia (p. ej. pestaña "Adjuntar Documentación"),
   * el padre puede reenviar este payload a todas las instancias de app-customfields.
   */
  @Output() tipoEmpresaSyncToType53AcrossTabs = new EventEmitter<{
    field53: any;
    tipoEmpresaId: string | number;
  }>();

  @Input() haveConfigShowFields: boolean = false;

  valueFieldsClon = [];
  customfields45 = [];
  subtype: string[] = [];
  itemId: number;
  democf = {};
  optionValue: string = "";
  fromCustomDate: NgbDateStruct = null;

  searchText: string;
  formCustomFields: FormGroup;
  // formRequirementFields: FormGroup;
  // items: FormArray;

  isEditing: boolean = false;
  isComuna: boolean = false;
  isDisabledDateSla: boolean = false;

  fieldIsNotEmpty: { [name: string]: boolean } = {};

  public options1: any;
  public nestedValues = [];
  public itemSelected = {};
  public counterTree = []

  setSelectValue: number;
  seleccionados = [];

  checkboxesCollection = [];
  filterFields = [];
  arrkey = [];
  fieldArrayMateria = [];

  public repeatList: FormArray[] = [];
  items: FormArray;
  dateValueSet: any;
  //#endregion

  dynamicFields: { [fieldId: number]: string[] } = {};
  // Estructura para rastrear campos dinámicos dentro de tipo 48: dynamicFieldsType48[type48FieldId][rowIndex][type6FieldId] = [fieldNames]
  dynamicFieldsType48: { [type48FieldId: number]: { [rowIndex: number]: { [type6FieldId: number]: string[] } } } = {};
  /** Visibilidad de un hijo tipo 48 por fila. El objeto del campo es compartido entre filas. */
  private type48RowHidden = new Map<string, boolean>();

  STATUS_VALID = 'VALID';

  /** Suscripciones al motor genérico `computed_rules` (columna en BD). */
  private computedRulesSubscription: Subscription | null = null;

  CUSTOMFIELD_NESTED = 14;
  CUSTOMFIELD_NESTED_DUAL = 55;

  constructor(
    private fb: FormBuilder,
    public _requirements: RequirementService,
    private calendar: NgbCalendar,
    private cdr: ChangeDetectorRef,
    private comuna: ComunaService,
    private areaService: AreaService,
    private subType20: Type20Service,
    private type22: Type22Service,
    private _customfields: CustomfieldsService,
    private dateformatService: DateformatService,
    public modalService: NgbModal
  ) {
  }

  ngAfterViewInit(): void {
      console.log('Entra')
      setTimeout(()=>{
        this.initializeDynamicFields();
        // Verificar que formCustomFields esté inicializado antes de acceder a sus propiedades
        if (this.formCustomFields) {
          // Marcar el formulario como dirty y touched si está en modo edición y tiene valores
          if (this.edit && this.formCustomFields.value && Object.keys(this.formCustomFields.value).length > 0) {
            // Marcar todos los controles como dirty y touched para que el botón se active
            Object.keys(this.formCustomFields.controls).forEach(key => {
              const control = this.formCustomFields.controls[key];
              if (control.value !== null && control.value !== undefined && control.value !== '') {
                control.markAsDirty();
                control.markAsTouched();
              }
            });
            // Marcar el formulario completo como dirty
            this.formCustomFields.markAsDirty();
            this.formCustomFields.markAsTouched();

            // Forzar actualización de validación
            this.formCustomFields.updateValueAndValidity({ emitEvent: false });
          }

          let form = { valid: this.formCustomFields.status == this.STATUS_VALID, value: this.formCustomFields.value };
          console.log('🔵 Emitting form values in ngAfterViewInit:', form);
          this.customfieldsValues.emit(form);
        }
      },100);
  }


  getDefinitionCustomfields(items, value, flag) {
    const customfields = {};
    const discardValues = [null, ''];

    if (items == null || !Array.isArray(items)) {
      return customfields;
    }

    items.map((item, index) => {
      // Referencias rotas en values del tipo 48 (campo hidden / inexistente) → undefined
      if (!item || item.id == null) {
        return;
      }

      // El API a veces envía type como string ("3"); el switch() usa === y no matchearía case 3.
      if (item.type !== null && item.type !== undefined && item.type !== '') {
        const typeNum = Number(item.type);
        if (!Number.isNaN(typeNum)) {
          item.type = typeNum;
        }
      }

      const loadLast = item.loadlastvalue === true || item.loadlastvalue === 1
        || String(item.loadlastvalue).toLowerCase() === 'true';

      // Si item.value está definido y flag es true (modo edición), usarlo
      // Si item.value está definido y flag es false pero item tiene la propiedad _hasPreservedValue (creación con valores guardados), también usarlo
      // Esto permite preservar valores al navegar entre pasos en requirement-add sin afectar requirement-detail
      value = (item.value && flag) || (item.value && item._hasPreservedValue)
        ? item.value
        : (loadLast && item.defaultvalue) ? item.defaultvalue
        : (loadLast && item.formula) ? item.defaultvalue
        : (!flag && !item.value && item.type === 3 && item.defaultvalue) ? item.defaultvalue
        : "";

      // Convertir string a boolean para tipo 4 (checkbox) y tipo 54 (toggle switch) cuando viene del backend
      if ((item.type === 4 || item.type === 54) && typeof value === 'string') {
        value = (value === 'true' || value === '1');
      }

      // Campos readonly / sourceField (ej. Responsable Tienda en modal "Cambiar a estado"):
      // el modal monta customfields con edit=false y antes descartaba item.value;
      // además el fallback exigía !item.value, lo que impedía usar defaultvalue cuando ambos venían poblados.
      if (!value && item.readonly && (item.value || item.defaultvalue)) {
        value = item.value || item.defaultvalue;
        item.disabled = false;
      }

      // Parsear values para tipo 54 (toggle switch) si viene como string
      if (item.type === 54) {
        if (item.values && typeof item.values === 'string') {
          try {
            // Limpiar el string si tiene comillas simples o dobles alrededor
            let cleanedString = item.values.trim();
            if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
              cleanedString = cleanedString.slice(1, -1);
              // Reemplazar comillas escapadas si es necesario
              cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
            }
            item.values = JSON.parse(cleanedString);
            console.log('✅ Parsed values for toggle field in getDefinitionCustomfields:', item.name, item.values);
          } catch (e) {
            console.error('❌ Error parsing values for toggle field in getDefinitionCustomfields:', item.name, e);
            // Si no es JSON válido, usar valores por defecto
            item.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
          }
        } else if (!item.values) {
          // Si no hay values, usar valores por defecto
          item.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
          console.log('⚠️ No values found for toggle field in getDefinitionCustomfields:', item.name, 'using defaults');
        } else if (typeof item.values === 'object') {
          // Ya es un objeto, asegurarse de que tenga las propiedades necesarias
          if (!item.values.leftLabel) item.values.leftLabel = 'Opción 1';
          if (!item.values.rightLabel) item.values.rightLabel = 'Opción 2';
          console.log('✅ Values already parsed for toggle field in getDefinitionCustomfields:', item.name, item.values);
        }
      }

      let itemValue: any = [];
      let fieldArray: FormGroup[];

      if (item.type === 14 || item.type === 55) {
        this.nestedValues.push(item.values)
        this.counterTree.push({ id: item.id, index: this.nestedValues.length - 1 })
      }

      if ((item.type === 12 || item.type === 13 || item.type === 10) && (this._customfields.isType(item.value, 'string') && item.value.includes('['))) { item.value = JSON.parse(item.value); }

      if (item.disabled && !(this._customfields.isType(item.value, 'string') && item.value.includes('['))) {
        value = { value, disabled: item.disabled };
      }

      let validator;

      if (!this.edit && item.required == true){
        validator = !item.showincreate ? [] : [Validators.required];
      }else{
        validator = item.required ? [Validators.required] : [];
      }


      switch (item.type) {
        case 1: // Input number
          customfields[item.id] = [value];
          break;
        case 2: { // Input text
          const type2Validators = Array.isArray(validator) ? [...validator] : [];
          if (item.regularexpression) {
            type2Validators.push(Validators.pattern(item.regularexpression));
          }
          customfields[item.id] = [value, type2Validators];
          break;
        }
        case 3: // Input calendar
          let isDateSLA = (item.name === 'Fecha Plazo' || item.name === 'Fecha firma contrato') ? true : false;
          // let validatorfecha = item.required || isDateSLA ? [Validators.required] : [];
          let validatorfecha = item.required ? [Validators.required] : [];
          customfields[item.id] = [isDateSLA && value.length == 0 ? null : value === '' ? null : value === 'null' ? null : value, validatorfecha];
          break;
        case 4: // Checkbox
          // Convertir valor a boolean: "true", true, "1", 1 -> true; otros -> false
          let checkboxValue = false;
          if (value === true || value === 'true' || value === '1' || value === 1) {
            checkboxValue = true;
          } else if (value === false || value === 'false' || value === '0' || value === 0 || value === '' || value === null) {
            checkboxValue = false;
          }
          // Si tiene defaultvalue, usarlo si no hay valor
          if (checkboxValue === false && item.defaultvalue) {
            checkboxValue = (item.defaultvalue === 'true' || item.defaultvalue === true || item.defaultvalue === '1' || item.defaultvalue === 1);
          }
          customfields[item.id] = [checkboxValue, validator];
          break;
        case 54: // Toggle Switch
          // Convertir valor a boolean: "true", true, "1", 1 -> true; otros -> false
          let toggleValue = false;
          if (value === true || value === 'true' || value === '1' || value === 1) {
            toggleValue = true;
          } else if (value === false || value === 'false' || value === '0' || value === 0 || value === '' || value === null) {
            toggleValue = false;
          }
          // Si tiene defaultvalue, usarlo si no hay valor
          if (toggleValue === false && item.defaultvalue) {
            toggleValue = (item.defaultvalue === 'true' || item.defaultvalue === true || item.defaultvalue === '1' || item.defaultvalue === 1);
          }
          // Parsear values para obtener leftLabel y rightLabel (ya debería estar parseado arriba, pero por si acaso)
          if (item.values && typeof item.values === 'string') {
            try {
              // Limpiar el string si tiene comillas simples o dobles alrededor
              let cleanedString = item.values.trim();
              if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                  (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
                cleanedString = cleanedString.slice(1, -1);
                // Reemplazar comillas escapadas si es necesario
                cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
              }
              item.values = JSON.parse(cleanedString);
              console.log('✅ Parsed values in case 54:', item.name, item.values);
            } catch (e) {
              console.error('❌ Error parsing values in case 54:', item.name, e);
              // Si no es JSON válido, usar valores por defecto
              item.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
            }
          } else if (!item.values) {
            item.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
            console.log('⚠️ No values found in case 54:', item.name, 'using defaults');
          } else if (typeof item.values === 'object') {
            // Ya es un objeto, asegurarse de que tenga las propiedades necesarias
            if (!item.values.leftLabel) item.values.leftLabel = 'Opción 1';
            if (!item.values.rightLabel) item.values.rightLabel = 'Opción 2';
            console.log('✅ Values already object in case 54:', item.name, item.values);
          }
          customfields[item.id] = [toggleValue, validator];
          break;
        case 5: // Select Simple
          item.values = this.parseSelectSimpleValues(item.values);
          customfields[item.id] = (item.values && item.values.length === 1) ? [item.values[0], validator] : [value, validator];
          break;
        case 37: // Select Simple
          item.values = this.parseSelectSimpleValues(item.values);
          customfields[item.id] = (item.values && item.values.length === 1) ? [item.values[0], validator] : [value, validator];
          break;
        case 6: // Select Simple
          if (item.hasOwnProperty('values') && item.values && item.values.length > 0) {
            const defaultOption = item.values.find((option) => option.selected);
            if (defaultOption) {
              if (!item.value || item.value == '' || item.value == defaultOption.name) {
                item.value = defaultOption.name;
                value = defaultOption.name;
              }
            }
          }
          customfields[item.id] = [value, validator];
          break;
        case 8: // Input RUT
          customfields[item.id] = [value, [correctRutValidator()]];
          break;
        case 7:
        case 9: // TEXTAREA DOUBLE SPACE AND TEXTAREA SIMPLE
          customfields[item.id] = [value, validator];
          break;
        case 10: // grupo de checkbox: siempre pintar todas las opciones (item.values); en edición mezclar con item.value para el checked
          this.checkboxesCollection.push(item['id']);
          try {
            itemValue = item['value'];
            fieldArray = [];
          } catch (error) { }
          const fullOptions = Array.isArray(item['values']) ? item['values'] : [];
          const savedOptions = (itemValue && Array.isArray(itemValue)) ? itemValue : [];
          const mergedOptions = fullOptions.map((opt: { name: string }) => {
            const saved = savedOptions.find((s: any) => s && s.name === opt.name);
            return { name: opt.name, value: !!(saved && saved.value) };
          });
          const initInputCollectionType10 = mergedOptions.map((v: { name: string; value: boolean }) => this.initInputCollectionTypeM(v));
          customfields[item.id] = this.fb.array(initInputCollectionType10);
          break;
        case 12:
          const initInputCollection12 = item['value'] ?
            item['value'].map(v => this.initInputCollectionType(item.type, v)) :
            [this.initInputCollectionType(item.type, '')];
          customfields[item.id] = this.fb.array(initInputCollection12);
          break;
        case 13:
          const initInputCollection = item['value'] ?
            item['value'].map(v => this.initInputCollectionType(item.type, v)) :
            [this.initInputCollectionType(item.type, '')];
          customfields[item.id] = this.fb.array(initInputCollection);
          break;
        case 14:
          customfields[item.id] = this.fb.array([this.initInputCollection(item.type, value)]);
          break;
        case 55:
          customfields[item.id] = this.fb.array([this.initInputCollection55(value)]);
          break;
        case 53: // SELECT TIPO EMPRESA CON DOCUMENTOS Y ARCHIVOS
          try {
            if (typeof item.values === 'string' && item.values.includes('[')) {
              item.values = JSON.parse(item.values);
            }
            if (this.edit && value) {
              try {
                const parsedValue = typeof value === 'string' ? JSON.parse(value) : value;
                customfields[item.id] = this.fb.group({
                  tipoEmpresa: [parsedValue.tipoEmpresa || ''],
                  documentos: this.fb.array(
                    (parsedValue.documentos || []).map((doc: any) =>
                      this.fb.group({
                        fileId: [doc.fileId || ''],
                        fileName: [doc.fileName || ''],
                        file: [doc.file || null]
                      })
                    )
                  )
                });
              } catch (error) {
                customfields[item.id] = this.fb.group({
                  tipoEmpresa: [''],
                  documentos: this.fb.array([])
                });
              }
            } else {
              customfields[item.id] = this.fb.group({
                tipoEmpresa: [''],
                documentos: this.fb.array([])
              });
            }
          } catch (error) {
            customfields[item.id] = this.fb.group({
              tipoEmpresa: [''],
              documentos: this.fb.array([])
            });
          }
          break;
        case 15: // EMAIL
          // Usar validador de email más estricto que Validators.email
          validator.push(validEmailValidator());
          customfields[item.id] = [value, validator];
          break;
        case 16: // HOURS
          validator.push(Validators.required)
          customfields[item.id] = [item.value];
          break;
        case 18: // Search Input dinamically with some  created fields
          try {
            itemValue = JSON.parse(item.value);
            fieldArray = [];
          } catch (error) { }
          let itemId = item.id;

          let valuesGet = item.value;
          if (itemValue.length) {
            for (const reason of itemValue) {
              if (reason.additionalFields) {
                fieldArray.push(
                  this.fb.group({
                    value: [reason.value],
                    data: item.values,
                    tipoMoneda: reason.additionalFields.tipoMoneda,
                    montoMulta: reason.additionalFields.montoMulta,
                  })
                );
              } else {
                fieldArray.push(
                  this.fb.group({
                    value: [reason.value],
                    data: item.values,
                  })
                );
              }
            }
            customfields[item.id] = this.fb.array(fieldArray);
            this.isEditing = true;
          } else {
            let settingValue = valuesGet ? valuesGet[0].value : "";

            customfields[item.id] = this.fb.array([
              this.fb.group({
                id: item.values.customfieldgroupid,
                value: settingValue,
                data: item.values,
              }),
            ]);
            if (valuesGet) {
              let set_item = {
                id: item.id,
                type: item.type,
              };
              let mapIt = valuesGet.map((x: any, index: number) => {
                if (index !== 0) {
                  setTimeout(() => {
                    this.addData({ field: set_item, val: x.value });
                  }, 100);
                }
              });
            }
          }
          break;
        case 19: // Search Input dinamically
          customfields[item.id] = this.fb.array([]);
          const adittionalItems = item.data.adittional_fields;
          if (item.value) {
            item.value.map((it) => {
              const myObj = {};
              adittionalItems.map((x, index) => {
                if (index === 0) {
                  myObj[x.field] = [it[x.field]];
                } else {
                  myObj[x.field] = [it[x.field]];
                }
              });
              (customfields[item.id] as FormArray).push(this.fb.group(myObj));
            });
          } else {
            item.values.map((fieldItem: any) => {
              const myObj = {};
              adittionalItems.map((i, index) => {
                // i.formData  = fieldItem;
                if (index === 0) {
                  myObj[i.field] = [fieldItem];
                } else {
                  myObj[i.field] = [""];
                }
              });
              (customfields[item.id] as FormArray).push(this.fb.group(myObj));
            });
          }
          break;
        case 20: // Recurso
          try {
            if (typeof item.values === 'string' && item.values.includes('[')) {
              item.values = JSON.parse(item.values);
            }
            if (typeof item.value === 'string' && item.value.includes('{')) {
              itemValue = [JSON.parse(item.value)];
            } else {
              itemValue = [item.value];
            }
          } catch (error) { }

          if (this.edit && itemValue.length > 0) {
            customfields[item.id] = this.fb.group({
              type: [itemValue[0].idtype ? itemValue[0].idtype : ''],
              subtype: [itemValue[0].subtype ? itemValue[0].subtype : ''],
            });
            if (itemValue[0].subtype)
              this.subType20.changeOption(itemValue[0].idtype, item.values.subtype.data)
          } else {
            customfields[item.id] = this.fb.group({
              type: [''],
              subtype: [''],
            });
          }
          this.subType20.customOption.subscribe(type => this.subtype = type)
          break;
        case 21: // Radios button
          try {
            item.values = item.values.includes('[') ? JSON.parse(item.values) : item.values;
            if (this.edit) {
              let itemValue = JSON.parse(value);
              value = itemValue.si ? 'si' : 'no';
            }

          } catch (error) { }
          customfields[item.id] = [value];

          break;
        case 22: // Tipo plazo
          try {
            if (typeof item.values === 'string' && item.values.includes('[')) {
              item.values = JSON.parse(item.values);
            }
            if (typeof item.value === 'string' && item.value.includes('{')) {
              itemValue = [JSON.parse(item.value)];
            } else {
              itemValue = [item.value];
            }
          } catch (error) { }
          if (this.edit && itemValue.length > 0) {
            try {
              if (itemValue[0].hasOwnProperty('type')) {
                this.type22.changeOption(itemValue[0].type.id);
              }
              customfields[item.id] = this.fb.group({
                type: [(itemValue[0].hasOwnProperty('type') && itemValue[0].type.id) ? itemValue[0].type.id : ''],
                condicion: [itemValue[0].condicion ? itemValue[0].condicion : null],
                fecharevision: [itemValue[0].fecharevision ? moment(itemValue[0].fecharevision, "YYYY-MM-DD").format('DD/MM/YYYY') : null],
                fechavencimiento: [itemValue[0].fechavencimiento ? moment(itemValue[0].fechavencimiento, "YYYY-MM-DD").format('DD/MM/YYYY') : null],
                avisoterminodias: [itemValue[0].avisoterminodias ? itemValue[0].avisoterminodias : null],
                periodicidad: [itemValue[0].periodicidad ? itemValue[0].periodicidad : null],
                renovacionautomatica: [itemValue[0].renovacionautomatica ? itemValue[0].renovacionautomatica.si ? 'si' : 'no' : 'no'],
                carta_aviso: [itemValue[0].carta_aviso.si ? 'si' : 'no']
              });
            } catch (error) {
              console.log(error)
            }


          } else {
            customfields[item.id] = this.fb.group({
              type: [''],
              condicion: [''],
              fecharevision: [null],
              fechavencimiento: [null],
              avisoterminodias: [null],
              periodicidad: [null],
              renovacionautomatica: [null],
            });
          }
          this.itemId = item.id;
          break;
        case 23: // Select Simple with input text
          try {
            if (this.edit) {
              value = JSON.parse(value).id;
            }
          } catch (error) { }
          customfields[item.id] = [value];
          break;
        case 24: // Terminado
          try {
            itemValue = [JSON.parse(item.value)];
            fieldArray = [];
          } catch (error) { }
          if (itemValue.length > 0) {
            this.itemId = item.id;
            customfields[item.id] = this.fb.group({
              cuantia_$: [itemValue[0].cuantia_$],
              monto_pagado_$: [itemValue[0].monto_pagado_$],
              monto_ahorrado_$: [itemValue[0].monto_ahorrado_$],
              porcentaje_ahorrado: [itemValue[0].porcentaje_ahorrado],
            });
          } else {
            this.itemId = item.id;
            customfields[item.id] = this.fb.group({
              //tip: [tipe],
              cuantia_$: [""],
              monto_pagado_$: [""],
              monto_ahorrado_$: [""],
              porcentaje_ahorrado: [""],
            });

            let customfieldId = item.values.customfieldid;
            this._requirements
              .getDataReqFields(customfieldId, this.reqId)
              .subscribe((resp) => {
                if (resp["result"]) {
                  let value = resp["result"]["value"];
                  this.setValueAndTermino(value);
                }
              });
          }
          break;
        case 25: // Multiples inputs
          let fields: FormArray = new FormArray([]);
          let values: string[];
          try {
            values = JSON.parse(item.value);
          } catch (error) { }

          if (values) {
            for (const val of values) {
              fields.push(new FormControl(val));
            }
            this.isEditing = true;
          } else {
            fields.push(new FormControl(""));
          }
          customfields[item.id] = fields;
          break;
        case 26: // Multiples selects anidados de 2 niveles
          try {
            itemValue = JSON.parse(item.value);
            fieldArray = [];
          } catch (error) { }
          item.values.child_items = [];
          if (itemValue.length) {
            for (const i in itemValue) {
              item.values.child_items[i] = item.values.items.find(
                (f) => f.value == itemValue[i].parent
              ).items;
              fieldArray.push(this.fb.group(itemValue[i]));
            }
            customfields[item.id] = this.fb.array(fieldArray);
          } else {
            if (
              item.value &&
              typeof item.value === "object" &&
              item.value.length > 0
            ) {
              fieldArray = [];
              for (const i in item.value) {
                item.values.child_items[i] = item.values.items.find(
                  (f) => f.value == item.value[i].parent
                ).items;
                fieldArray.push(this.fb.group(item.value[i]));
              }
              customfields[item.id] = this.fb.array(fieldArray);
            } else
              customfields[item.id] = this.fb.array([
                this.fb.group({ parent: "", child: "" }),
              ]);
          }
          break;
        case 27: // REPETIDOR
          let fieldsArray = [];
          if (item.value) {
            for (const it of item.value) {
              fieldsArray.push(this.fb.group(it));
            }
          } else {
            let repeaterField = {};
            for (const iterator of item.values) {
              repeaterField[iterator.field_name] = "";
            }
            fieldsArray.push(this.fb.group(repeaterField));
          }
          customfields[item.id] = this.fb.array(fieldsArray);
          break;
        case 28: // CUSTOMFIELD LISTA UN SELECTOR PARA LUEGO MOSTRAR SU DATO ASOCIADO A ESTE, OJO: SOLO TIENE QUE SER 1, EJM: SELECT DNI -> MUESTRA NOMBRE PERSONA
          customfields[item.id] = this.fb.group({
            select: item.value ? item.value["select"] : "",
            itemName: item.value ? item.value["itemName"] : "",
          });
          break;
        case 29: // Cumplimiento
          try {
            itemValue = JSON.parse(item.value);
            fieldArray = [];
          } catch (error) { }

          if (itemValue.length) {
            // CUANDO SE ENCUENTRE EN EDITAR
            // VA A RECORRER UN ARRAY DE OBJETOS PARA ASIGNAR A LOS CAMPOS DE CUSTOMFIELDS
            for (const i in itemValue) {
              const fieldItems = {};
              Object.entries(itemValue[i]).forEach(([key, value]) => {
                fieldItems[key] = value;
              });

              fieldArray.push(this.fb.group(fieldItems));
            }
            customfields[item.id] = this.fb.array(fieldArray);
            this.isEditing = true;
          } else {
            // CUANDO AGREGUE LOS CAMPOS
            const fieldGroup = {};
            item.values.fields.map((fieldItem) => {
              // AQUI CONVERTIMOS EL ARRAY A UN OBJETO PARA ASIGNARLO AL FORMBUILDER GROUP
              fieldGroup[fieldItem.field] = "";
            });
            customfields[item.id] = this.fb.array([this.fb.group(fieldGroup)]);
          }
          break;

        case 35:
          customfields[item.id] = null;
          break;
        case 36:
          customfields[item.id] = null;
          break;
        case 50: // select2 , search
          // Región proveedor (100000): usar valor guardado; el resto sigue siendo Área (stores)
          if (this.edit && (item.id === 100000 || item.id === '100000')) {
            customfields[item.id] = [value != null && value !== '' ? value : ''];
          } else {
            customfields[item.id] = this.edit ? [this.areaService.getOption()] : [value];
          }
          break;
        case 51: // select2 simple , search
          this.isComuna = item.id === 100001 ? true : false;
          customfields[item.id] = [value];
          this.isComuna ? this.comuna.customOption.subscribe(comunas => item.values = comunas) : this.areaService.customOption.subscribe(stores => item.values = stores);
          break;
        case 52: // select id/name: BD guarda JSON { id, value } o id legacy
          {
            const parsed = parseType52StoredValue(item.valueid ?? item.value);
            customfields[item.id] = [
              parsed.id != null && parsed.id !== '' && parsed.id !== 'null'
                ? parsed.id
                : '',
            ];
          }
          break;

        case 45: {
          try {
            customfields[item.id] = [this.formatearCampoCompleted(item)];
          } catch (err) {
            console.warn('[customfields] No se pudo calcular valor inicial para campo tipo 45:', item?.name, err);
            customfields[item.id] = [item.value ?? ''];
          }
          break;
        }
        case 48:
          customfields[item.id] = this.fb.array([]);
          break;
        case 49:
          customfields[item.id] = null;
          break;
      }
    });
    return customfields;
  }

  /**
   * Normaliza `values` de selects simples (tipo 5/37) a string[].
   * Acepta JSON string, array de strings u objetos { name } / { data, id } (legacy counterparty).
   */
  parseSelectSimpleValues(raw: unknown): string[] {
    if (raw == null || raw === '') {
      return [];
    }
    if (Array.isArray(raw)) {
      return raw
        .map((item) => {
          if (typeof item === 'string') {
            return item.trim();
          }
          if (item && typeof item === 'object') {
            const o = item as Record<string, unknown>;
            if (o.data != null && String(o.data).trim() !== '') {
              return String(o.data).trim();
            }
            if (o.name != null && String(o.name).trim() !== '') {
              return String(o.name).trim();
            }
            if (o.label != null && String(o.label).trim() !== '') {
              return String(o.label).trim();
            }
          }
          return item != null ? String(item).trim() : '';
        })
        .filter(Boolean);
    }
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      if (!trimmed) {
        return [];
      }
      if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          return this.parseSelectSimpleValues(JSON.parse(trimmed));
        } catch {
          return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
        }
      }
      return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
    }
    return [];
  }

  private normalizeFieldTypes(fields: any[]): void {
    if (!Array.isArray(fields)) {
      return;
    }
    fields.forEach((field) => {
      if (field?.type != null && field.type !== '') {
        const typeNum = Number(field.type);
        if (!Number.isNaN(typeNum)) {
          field.type = typeNum;
        }
      }
    });
  }

  private hydrateSelectSimpleFieldOptions(fields: any[]): void {
    if (!Array.isArray(fields)) {
      return;
    }
    fields.forEach((field) => {
      if (field.type === 5 || field.type === 37) {
        field.values = this.parseSelectSimpleValues(field.values);
      }
    });
  }

  private sanitizeSelectSimpleFieldValues(fields: any[]): void {
    if (!Array.isArray(fields)) return;
    for (const field of fields) {
      if (field.type !== 5 && field.type !== 37) continue;
      if (!Array.isArray(field.values)) continue;
      const before = field.values.length;
      field.values = field.values.filter((v: any) => {
        if (v != null && typeof v === 'object' && !Array.isArray(v) && v.name == null && v.label == null) {
          if ('percent' in v) {
            console.warn(
              '[customfields] Se quitó una entrada inválida de values (objeto tipo mapa de provisión). ' +
                'Eso va solo en computed_rules, no en values. Campo:',
              field.name
            );
            return false;
          }
        }
        return true;
      });
      if (before > 0 && field.values.length === 0) {
        console.warn(
          '[customfields] El select quedó sin opciones; use tipo numérico (1) para monto de provisión y values []. Campo:',
          field.name
        );
      }
    }
  }

  ngOnInit() {
    this.teardownComputedRulesSubscriptions();
    console.log('Entra')
    this.initializeAliasFields();
    console.log('this.fields',this.fields)
    if (this.edit) {
      // Buscar campos tipo 48 con datos ANTES de initialSubgroupLoad
      // para asegurarnos de incluir todos los campos que tienen datos guardados
      const originalFields = this.customfieldsAlls && this.customfieldsAlls.length > 0
        ? this.customfieldsAlls
        : this.fields;

      const type48FieldsWithData = originalFields.filter((field: any) =>
        field.type === 48 && field.value && field.value !== '' && field.value !== null
      );

      // Agregar campos tipo 48 con datos a resultCustomfieldsSubGrop si no están ya incluidos
      type48FieldsWithData.forEach((field48: any) => {
        const alreadyIncluded = this.resultCustomfieldsSubGrop.some((item: any) => item.id === field48.id);
        if (!alreadyIncluded) {
          // Usar values directamente del campo (viene del backend con estructura [{name: "...", alias: "..."}])
          // initialSubgroupLoad construirá customfields correctamente desde estos values
          const values = field48.values || [];

          this.resultCustomfieldsSubGrop.push({
            id: field48.id,
            values: values, // Para initialSubgroupLoad - estructura [{name: "...", alias: "..."}]
            value: field48.value // Los datos guardados en formato JSON string
          });
        }
      });

      this.isSubGrupo = this.resultCustomfieldsSubGrop.length > 0 ? true : false;

      // initialSubgroupLoad construirá customfields desde values para cada campo tipo 48
      let data = this._customfields.initialSubgroupLoad(this.fields, this.resultCustomfieldsSubGrop);
      this.fields = data.customfields;
      this.resultCustomfieldsSubGrop = data.result;

      // Parsear values en subcampos de agrupaciones tipo 48
      this.fields.forEach((field: any) => {
        if (field.type === 48 && field.customfields && Array.isArray(field.customfields)) {
          this.normalizeFieldTypes(field.customfields);
          this.hydrateSelectSimpleFieldOptions(field.customfields);
          field.customfields.forEach((subField: any) => {
            if (subField.type === 6 && typeof subField.values === 'string') {
              try {
                subField.values = JSON.parse(subField.values);
              } catch (e) {
                console.error('❌ Error parsing type 6 values in type 48:', subField.name, e);
              }
            }
            if (subField.type === 54) {
              if (subField.values && typeof subField.values === 'string') {
                try {
                  let cleanedString = subField.values.trim();
                  if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                      (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
                    cleanedString = cleanedString.slice(1, -1);
                    cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
                  }
                  subField.values = JSON.parse(cleanedString);
                  console.log('✅ Parsed values for toggle field in type 48 subgroup:', subField.name, subField.values);
                } catch (e) {
                  console.error('❌ Error parsing values for toggle field in type 48 subgroup:', subField.name, e);
                  subField.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
                }
              } else if (!subField.values) {
                subField.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
              } else if (typeof subField.values === 'object') {
                if (!subField.values.leftLabel) subField.values.leftLabel = 'Opción 1';
                if (!subField.values.rightLabel) subField.values.rightLabel = 'Opción 2';
              }
            }
          });
        }
      });
    } else {
      // En modo creación (requirement-add), también establecer isSubGrupo basándose en resultCustomfieldsSubGrop
      // que viene como Input desde el componente padre
      if (this.resultCustomfieldsSubGrop && Array.isArray(this.resultCustomfieldsSubGrop)) {
        this.isSubGrupo = this.resultCustomfieldsSubGrop.length > 0 ? true : false;
      }
    }
    if (this.terminarCausa) {
      this.filterFields = this.fields.filter((x) => x.type == 6 && (x.name === "Motivo" || x.name === "Estado"));
    } else if (!this.edit && !this.flagActionLog) {
      this.filterFields = this.fields.filter((x) => !x.hidden && x.showincreate !== false);
    } else {
      this.filterFields = this.fields;
    }
    let filterObjet = this.fields.filter((x) => x.type == 19);
    let indx = filterObjet.length - 1;
    if (filterObjet[indx]) {
      this.fields = this.fields.filter((x) => x.type !== 19);
      this.fields.push(filterObjet[indx]);
    }
    let value;

    // Procesar campos tipo 14 con valores preservados (requirement-add navegando hacia atrás)
    // Solo hacerlo si NO está en modo edición para no interferir con el flujo de edición
    if (!this.edit && !this.flagActionLog) {
      this.fields.forEach((field: any) => {
        if (field.type === 14 && field._hasPreservedValue && field.value) {
          // Procesar el valor para crear field.selected
          let fieldValue: any = null;
          // El valor guardado puede venir como string JSON o como array
          if (typeof field.value === 'string') {
            try {
              // Intentar parsear como JSON
              if (field.value.trim().startsWith('[') || field.value.trim().startsWith('{')) {
                const parsed = JSON.parse(field.value);
                fieldValue = Array.isArray(parsed) ? parsed[0] : parsed;
              } else {
                // Si no es JSON válido, usar el valor tal cual
                return;
              }
            } catch (e) {
              console.error('Error parsing type 14 value:', e, field.value);
              return;
            }
          } else if (Array.isArray(field.value)) {
            fieldValue = field.value[0]; // Tomar el primer elemento si es array
          } else if (typeof field.value === 'object') {
            fieldValue = field.value;
          } else {
            return;
          }

          // Verificar que fieldValue tenga la estructura esperada (seleccion y sub)
          if (fieldValue && fieldValue.seleccion !== undefined && field.values && Array.isArray(field.values)) {
            field.selected = this.formatAppTreeForEdit(field, fieldValue);
          }
        }
      });
    }

    if (this.edit || this.flagActionLog) {
      this.hydrateType14FieldsForEdit();
    }

    // Parsear values para campos tipo 54 (toggle switch) antes de crear el formulario
    this.fields.forEach((field: any) => {
      if (field.type === 54) {
        if (field.values && typeof field.values === 'string') {
          try {
            // Limpiar el string si tiene comillas simples o dobles alrededor
            let cleanedString = field.values.trim();
            if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
              cleanedString = cleanedString.slice(1, -1);
              // Reemplazar comillas escapadas si es necesario
              cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
            }
            field.values = JSON.parse(cleanedString);
            console.log('✅ Parsed values for toggle field in ngOnInit:', field.name, field.values);
          } catch (e) {
            console.error('❌ Error parsing values for toggle field in ngOnInit:', field.name, e, 'Raw value:', field.values);
            // Si no es JSON válido, usar valores por defecto
            field.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
          }
        } else if (!field.values) {
          // Si no hay values, usar valores por defecto
          field.values = { leftLabel: 'Opción 1', rightLabel: 'Opción 2' };
          console.log('⚠️ No values found for toggle field in ngOnInit:', field.name, 'using defaults');
        } else if (typeof field.values === 'object') {
          // Ya es un objeto, asegurarse de que tenga las propiedades necesarias
          if (!field.values.leftLabel) field.values.leftLabel = 'Opción 1';
          if (!field.values.rightLabel) field.values.rightLabel = 'Opción 2';
          console.log('✅ Values already parsed for toggle field in ngOnInit:', field.name, field.values);
        }
      }
    });
    console.log('pasa por aqui',this.fields);
    this.normalizeFieldTypes(this.fields);
    this.hydrateSelectSimpleFieldOptions(this.fields);
    this.sanitizeSelectSimpleFieldValues(this.fields);
    if (!this.terminarCausa) {
      this.filterFields = (!this.edit && !this.flagActionLog)
        ? this.fields.filter((x) => !x.hidden && x.showincreate !== false)
        : this.fields;
    }
    this.formCustomFields = this.fb.group(this.getDefinitionCustomfields(this.filterFields, value, this.edit || this.flagActionLog));
    console.log('this.formCustomFields',this.formCustomFields)
    this.setupComputedRulesSubscriptions();
    // Aplicar dependencias de campos tipo 54 (Toggle Switch) al inicializar
    // Usar setTimeout para asegurar que el formulario esté completamente inicializado
    setTimeout(() => {
      console.log('🔵 Initializing field dependencies for type 54 fields...');
      this.fields.forEach((field: any) => {
        if (field.type === 54) {
          console.log('🔵 Processing field type 54:', field.name, 'ID:', field.id);

          // Parsear fielddependencies si viene como string
          if (field.fielddependencies && typeof field.fielddependencies === 'string') {
            try {
              // Limpiar el string si tiene comillas simples o dobles alrededor
              let cleanedString = field.fielddependencies.trim();
              if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                  (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
                cleanedString = cleanedString.slice(1, -1);
                // Reemplazar comillas escapadas si es necesario
                cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
              }
              field.fielddependencies = JSON.parse(cleanedString);
              console.log('🔵 Parsed fielddependencies on init:', field.fielddependencies);
            } catch (parseError) {
              console.error('❌ Error parsing fielddependencies on init:', parseError, 'Raw value:', field.fielddependencies);
              field.fielddependencies = null;
            }
          } else if (!field.fielddependencies) {
            // Si fielddependencies es null, buscar el campo original en customfieldsAlls o fields
            const originalField = this.customfieldsAlls?.find((group: any) =>
              group.fields?.find((f: any) => f.id === field.id)
            )?.fields?.find((f: any) => f.id === field.id) ||
            this.fields?.find((f: any) => f.id === field.id);

            if (originalField && originalField.fielddependencies) {
              if (typeof originalField.fielddependencies === 'string') {
                try {
                  let cleanedString = originalField.fielddependencies.trim();
                  if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                      (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
                    cleanedString = cleanedString.slice(1, -1);
                    cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
                  }
                  field.fielddependencies = JSON.parse(cleanedString);
                  console.log('🔵 Found and parsed fielddependencies from original field on init:', field.fielddependencies);
                } catch (parseError) {
                  console.error('❌ Error parsing fielddependencies from original field on init:', parseError);
                  field.fielddependencies = null;
                }
              } else {
                field.fielddependencies = originalField.fielddependencies;
                console.log('🔵 Found fielddependencies from original field on init:', field.fielddependencies);
              }
            }
          }

          if (field.fielddependencies) {
            // Obtener el valor inicial del toggle (puede ser false, true, o el defaultvalue)
            let toggleValue = this.formCustomFields.controls[field.id]?.value;
            console.log('🔵 Raw toggle value from form:', toggleValue);
            console.log('🔵 Field defaultvalue:', field.defaultvalue);

            // Si no hay valor, usar el defaultvalue
            if (toggleValue === null || toggleValue === undefined) {
              if (field.defaultvalue === 'true' || field.defaultvalue === true || field.defaultvalue === '1' || field.defaultvalue === 1) {
                toggleValue = true;
                console.log('🔵 Using defaultvalue: true');
              } else {
                toggleValue = false;
                console.log('🔵 Using defaultvalue: false');
              }
            }

            // Convertir a boolean si es necesario
            toggleValue = toggleValue === true || toggleValue === 'true' || toggleValue === '1' || toggleValue === 1;

            console.log('🔵 Initializing toggle field:', field.name, 'Final initial value:', toggleValue);
            console.log('🔵 Calling handleFieldDependencies with initial value');

            // Aplicar dependencias con el valor inicial
            this.handleFieldDependencies(field, toggleValue);
          } else {
            console.warn('⚠️ Field type 54 has no fielddependencies:', field.name);
          }
        }
      });
      this.initCommonCounterpartyCascade();
    }, 200);

    // Emitir el estado del formulario después de cargar todos los valores iniciales
    // Esto asegura que el botón "Guardar Cambios" se active si el formulario es válido
    // También controlar Región y Comuna según el país seleccionado
    setTimeout(() => {
      if (this.formCustomFields) {
        // Verificar y controlar Región y Comuna según el país seleccionado (tanto en creación como edición)
        const paisField = this.fields.find((f: any) => f.type === 6 && f.name === 'País');
        if (paisField && this.formCustomFields.controls[paisField.id]) {
          this.syncChileLocationFields(this.formCustomFields.controls[paisField.id].value);
          this.cdr?.markForCheck();
        }

        if (this.edit) {
          // Primero, forzar validación de todos los controles sin marcar como dirty
          Object.keys(this.formCustomFields.controls).forEach(key => {
            const control = this.formCustomFields.controls[key];
            control.updateValueAndValidity({ emitEvent: false });
          });

          // Forzar actualización de validación del formulario completo
          this.formCustomFields.updateValueAndValidity({ emitEvent: false });

          // Verificar si el formulario es válido
          const formStatus = this.formCustomFields.status === this.STATUS_VALID;
          const formValue = this.formCustomFields.value;

          // Si el formulario es válido y tiene valores, marcarlo como dirty para habilitar el botón
          if (formStatus && formValue && Object.keys(formValue).length > 0) {
            // Marcar todos los controles con valores como dirty
            Object.keys(this.formCustomFields.controls).forEach(key => {
              const control = this.formCustomFields.controls[key];
              if (control.value !== null && control.value !== undefined && control.value !== '') {
                control.markAsDirty();
                control.markAsTouched();
              }
            });

            // Marcar el formulario completo como dirty
            this.formCustomFields.markAsDirty();
            this.formCustomFields.markAsTouched();
          }

          console.log('🔵 Emitting initial form state after loading values:', {
            valid: formStatus,
            dirty: this.formCustomFields.dirty,
            status: this.formCustomFields.status,
            hasValues: formValue && Object.keys(formValue).length > 0
          });

          // Emitir el estado actual del formulario (válido o no)
          let form = {
            valid: formStatus,
            value: formValue
          };
          this.customfieldsValues.emit(form);

          // Forzar detección de cambios
          if (this.cdr) {
            this.cdr.detectChanges();
          }
        }
      }
    }, 300);

    if (this.isSubGrupo && this.resultCustomfieldsSubGrop && Array.isArray(this.resultCustomfieldsSubGrop)) {
      this.resultCustomfieldsSubGrop.forEach(element => {
        if (!element || element.id == null) return;
        if (element.hidden || element.showincreate === false) return;
        if (!this.formCustomFields.controls[element.id]) return;
        this.edit || this.flagActionLog ? this.editRepeat(element, element.id) : this.addRepeat('', element, element.id);
      });
    }

    // options for select 2
    this.options1 = {
      theme: "classic",
      width: "199",
      placeholder: "Seleccionar",
    };

  }

  createSubGroup(element): FormGroup {
    return this.fb.group(element);
  }

  listSubGroup(field) {
    let list = this.formCustomFields.controls[field.id];
    return list['controls'];
  }

  private repeatDeps(field: any): any {
    let deps = field?.fielddependencies;
    if (deps == null || deps === '') return null;
    if (typeof deps === 'string') {
      try {
        deps = JSON.parse(deps);
      } catch {
        return null;
      }
    }
    return deps;
  }

  /** Un solo bloque, sin "+" ni fila numerada. Lo activa fielddependencies.single. */
  isSingleRepeat(field: any): boolean {
    return this.repeatDeps(field)?.single === true;
  }

  repeatHeading(field: any, index: number): string {
    const label = this.repeatDeps(field)?.repeatLabel;
    if (label) return `${label} N.° ${index + 1}`;
    const word = String(field?.alias || '').split(' ')[1] || '';
    return `${word} # ${index + 1}`;
  }

  emptyRepeatText(field: any): string {
    return this.repeatDeps(field)?.emptyText || 'Pulse el botón + para agregar datos';
  }

  hasCopyFromGroup(item: any): boolean {
    return !!readCopyFromGroup(item);
  }

  private type48RowHiddenKey(type48FieldId: number | string, rowIndex: number, fieldId: number | string): string {
    return `${type48FieldId}:${rowIndex}:${fieldId}`;
  }

  /** Al borrar una fila el FormArray corre los índices; las claves viejas mostrarían la visibilidad de otra fila. */
  private refreshType48VisibilityAfterRowRemoved(type48FieldId: number | string): void {
    const prefix = `${type48FieldId}:`;
    for (const key of Array.from(this.type48RowHidden.keys())) {
      if (key.startsWith(prefix)) {
        this.type48RowHidden.delete(key);
      }
    }
    delete this.dynamicFieldsType48[type48FieldId as number];

    const rows = this.repeatList[type48FieldId as number] as FormArray;
    if (!rows) return;
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      this.reevaluateAllDynamicFieldsInRow(Number(type48FieldId), rowIndex);
    }
  }

  /** [hidden] por fila. Los hijos de un tipo 6 empiezan ocultos hasta que su opción los abre. */
  isType48ChildHidden(type48FieldId: number | string, rowIndex: number, item: any): boolean {
    if (!item) return false;
    const key = this.type48RowHiddenKey(type48FieldId, rowIndex, item.id);
    if (this.type48RowHidden.has(key)) {
      return !!this.type48RowHidden.get(key);
    }
    if (this.isType48DynamicChild(type48FieldId, item)) {
      return true;
    }
    return !!item.hidden;
  }

  /** true si algún tipo 6 del mismo grupo lo muestra solo al elegir una opción. */
  private isType48DynamicChild(type48FieldId: number | string, item: any): boolean {
    const group = (this.fields || []).find((field) => field && String(field.id) === String(type48FieldId));
    const siblings = group?.customfields;
    if (!Array.isArray(siblings) || !item?.name) {
      return false;
    }
    return siblings.some((sibling) =>
      sibling && Number(sibling.type) === 6 && sibling !== item && this.type6ListsField(sibling, item.name)
    );
  }

  /** fielddependencies.span = 12: el texto sigue siendo tipo 2 y ocupa la fila. */
  layoutSpansFull(item: any): boolean {
    if (!item) return false;
    let deps = item.fielddependencies;
    if (deps == null || deps === '') return false;
    if (typeof deps === 'string') {
      try {
        deps = JSON.parse(deps);
      } catch {
        return false;
      }
    }
    return Number(deps?.span) === 12;
  }

  isCopySourceIndexField(type48Field: any, item: any): boolean {
    const siblings = type48Field?.customfields || [];
    return siblings.some((sibling) =>
      sibling && sibling !== item && sibling.name !== item?.name
      && readCopyFromGroup(sibling)?.sourceIndexField === item?.name
    );
  }

  copyAllowsOther(item: any): boolean {
    return !!readCopyFromGroup(item)?.allowOther;
  }

  copyOtherLabel(item: any): string {
    return readCopyFromGroup(item)?.otherLabel || 'Otro';
  }

  copyOtherValue(item: any): string {
    return readCopyFromGroup(item)?.otherValue || 'otro';
  }

  private readonly noCopyOptions: { index: number; label: string }[] = [];
  private copyOptionsCache = new Map<any, { count: number; options: { index: number; label: string }[] }>();

  copySourceOptionsFor(item: any): { index: number; label: string }[] {
    const cfg = readCopyFromGroup(item);
    if (!cfg || !this.formCustomFields) return this.noCopyOptions;
    const source = this.findType48ByName(cfg.sourceGroup);
    const arr = source ? this.formCustomFields.controls[source.id] as FormArray : null;
    const count = arr?.controls?.length || 0;
    if (!count) return this.noCopyOptions;
    const cached = this.copyOptionsCache.get(item.id);
    if (cached && cached.count === count) return cached.options;
    const label = cfg.sourceLabel || source.alias || source.name;
    const options = arr.controls.map((_, index) => ({ index, label: `${label} N.° ${index + 1}` }));
    this.copyOptionsCache.set(item.id, { count, options });
    return options;
  }

  copyIndexFieldIdFor(type48Field: any, item: any): number | string | null {
    const cfg = readCopyFromGroup(item);
    if (!cfg?.sourceIndexField) return null;
    const sibling = (type48Field?.customfields || []).find((child) => child && child.name === cfg.sourceIndexField);
    return sibling ? sibling.id : null;
  }

  private findType48ByName(name: string): any {
    return (this.fields || []).find((field) => field && field.type === 48 && field.name === name) || null;
  }

  private type48Row(type48FieldId: number, rowIndex: number): FormGroup | null {
    const arr = this.formCustomFields?.controls?.[type48FieldId] as FormArray;
    const row = arr?.at?.(rowIndex) as FormGroup;
    return row || null;
  }

  private childByName(type48: any, name: string): any {
    if (!name) return null;
    return (type48?.customfields || []).find((child) => child && child.name === name) || null;
  }

  private rowControl(row: FormGroup, id: number | string): AbstractControl | null {
    if (!row || id == null) return null;
    return row.controls[id] ?? row.controls[String(id)] ?? null;
  }

  /** Si falta el departamento, lo deduce desde la provincia copiada. */
  private resolveType14DepartamentoId(field: any, saved: any): string {
    this.ensureType14TreeValues(field);
    let seleccion = this.coerceType14Scalar(saved?.seleccion);
    if (seleccion) {
      return seleccion;
    }
    const normalizedSub = this.normalizeType14SubArray(saved?.sub);
    const provinciaId = normalizedSub.find((item) => item.seleccion1 != null && item.seleccion1 !== '')?.seleccion1;
    if (provinciaId == null || !Array.isArray(field.values)) {
      return '';
    }
    for (const departamento of field.values) {
      const match = (departamento?.sub || []).some(
        (provincia: any) => String(provincia?.id) === String(provinciaId)
      );
      if (match) {
        return String(departamento.id);
      }
    }
    return '';
  }

  /** Copia ubigeo (dep/prov/dist) sobre el FormArray existente y refresca Provincia/Distrito. */
  private applyType14CopiedValue(toField: any, targetRow: FormGroup, fromCtrl: AbstractControl): void {
    this.ensureType14TreeValues(toField);
    const raw = typeof (fromCtrl as any).getRawValue === 'function'
      ? (fromCtrl as any).getRawValue()
      : fromCtrl.value;
    let saved: any = Array.isArray(raw) ? raw[0] : raw;
    if (typeof saved === 'string' && saved) {
      try {
        const parsed = JSON.parse(saved);
        saved = Array.isArray(parsed) ? parsed[0] : parsed;
      } catch {
        saved = { seleccion: '', sub: [] };
      }
    }
    if (!saved || typeof saved !== 'object') {
      saved = { seleccion: '', sub: [] };
    }
    const seleccion = this.resolveType14DepartamentoId(toField, saved);
    const normalizedSub = this.normalizeType14SubArray(saved.sub);
    let arr = this.rowControl(targetRow, toField.id) as FormArray;
    if (!(arr instanceof FormArray)) {
      arr = this.fb.array([
        this.fb.group({
          seleccion: [seleccion],
          sub: this.fb.array([]),
        }),
      ]);
      targetRow.setControl(String(toField.id), arr);
    }
    let group = arr.at(0) as FormGroup;
    if (!(group instanceof FormGroup)) {
      group = this.fb.group({
        seleccion: [seleccion],
        sub: this.fb.array([]),
      });
      if (arr.length === 0) {
        arr.push(group);
      } else {
        arr.setControl(0, group);
      }
    }
    group.get('seleccion')?.setValue(seleccion, { emitEvent: false });
    let sub = group.get('sub') as FormArray;
    if (!(sub instanceof FormArray)) {
      sub = this.fb.array([]);
      group.setControl('sub', sub);
    }
    while (sub.length) {
      sub.removeAt(0);
    }
    for (const subItem of normalizedSub) {
      const flat: Record<string, string> = {};
      for (const [key, value] of Object.entries(subItem)) {
        flat[key] = String(value);
      }
      sub.push(this.fb.group(flat));
    }
    const fieldValue = { seleccion, sub: normalizedSub };
    toField.value = [fieldValue];
    toField.selected = this.formatAppTreeForEdit(toField, fieldValue);
    toField._type14RefreshToken = Date.now();
  }

  /**
   * true = hay copia activa; false = interruptor apagado (forzar editable);
   * null = esta fila no usa interruptor (p. ej. copia automática del Beneficiario Final).
   */
  rowCopyLocksActive(type48Field: any, rowIndex: number): boolean | null {
    const autoCfg = readCopyFromGroup(type48Field);
    if (autoCfg?.auto) return null;
    const row = this.type48Row(type48Field?.id, rowIndex);
    if (!row) return null;
    let hasTrigger = false;
    for (const child of type48Field?.customfields || []) {
      const cfg = readCopyFromGroup(child);
      if (!cfg || cfg.lockCopied === false) continue;
      hasTrigger = true;
      const raw = row.controls[child.id]?.value;
      const active = cfg.allowOther ? isSourceIndex(raw) : isCheckedValue(raw);
      if (active) return true;
    }
    return hasTrigger ? false : null;
  }

  private handleCopyFromGroupChange(field: any, e: any, type48FieldId: number, rowIndex: number): void {
    const cfg = readCopyFromGroup(field);
    if (!cfg) return;
    const row = this.type48Row(type48FieldId, rowIndex);
    if (!row) return;
    const fromIndex = !!(e && e.target && e.target.copySourceIndex);
    const checked = isCheckedValue(row.controls[field.id]?.value);
    if (fromIndex) {
      if (checked) this.copyFromGroupIntoRow(field, type48FieldId, rowIndex);
      this.syncCopyLocksForRow(type48FieldId, rowIndex);
      return;
    }
    if (Number(field.type) === 4) {
      if (checked) this.copyFromGroupIntoRow(field, type48FieldId, rowIndex);
      else this.clearCopiedFieldValues(field, type48FieldId, rowIndex);
      this.syncCopyLocksForRow(type48FieldId, rowIndex);
      return;
    }
    if (Number(field.type) === 5 || Number(field.type) === 6) {
      const value = row.controls[field.id]?.value;
      const other = cfg.otherValue || 'otro';
      if (value === '' || value == null || String(value) === other || !isSourceIndex(value)) {
        // "Otro" / vacío: quitar datos del RL previo (no solo desbloquear).
        this.clearCopiedFieldValues(field, type48FieldId, rowIndex);
      } else {
        this.copyFromGroupIntoRow(field, type48FieldId, rowIndex);
      }
      this.syncCopyLocksForRow(type48FieldId, rowIndex);
    }
  }

  private copyFromGroupIntoRow(field: any, type48FieldId: number, rowIndex: number): void {
    const cfg = readCopyFromGroup(field);
    const targetGroup = (this.fields || []).find((item) => item && item.id === type48FieldId && item.type === 48);
    const targetRow = this.type48Row(type48FieldId, rowIndex);
    const sourceGroup = cfg ? this.findType48ByName(cfg.sourceGroup) : null;
    const sourceArray = sourceGroup ? this.formCustomFields.controls[sourceGroup.id] as FormArray : null;
    if (!cfg || !targetGroup || !targetRow || !sourceGroup || !sourceArray || sourceArray.length === 0) return;

    const index = this.clampSourceIndex(cfg, field, targetGroup, targetRow, sourceArray.length);
    if (index == null) return;
    const sourceRow = sourceArray.at(index) as FormGroup;
    if (!sourceRow) return;

    for (const pair of cfg.map || []) {
      const from = this.childByName(sourceGroup, pair.from);
      const to = this.childByName(targetGroup, pair.to);
      const fromCtrl = from ? this.rowControl(sourceRow, from.id) : null;
      if (!to || !fromCtrl) continue;
      if (Number(to.type) === 14) {
        this.applyType14CopiedValue(to, targetRow, fromCtrl);
        continue;
      }
      const toCtrl = this.rowControl(targetRow, to.id);
      if (!toCtrl) continue;
      const raw = typeof fromCtrl.getRawValue === 'function' ? fromCtrl.getRawValue() : fromCtrl.value;
      try {
        toCtrl.setValue(raw == null ? '' : JSON.parse(JSON.stringify(raw)), { emitEvent: false });
      } catch {
        toCtrl.setValue(raw ?? '', { emitEvent: false });
      }
    }

    for (const pair of cfg.copyActiveOption || []) {
      this.copyActiveOptionIntoRow(pair, sourceGroup, sourceRow, targetGroup, targetRow);
    }

    this.reevaluateAllDynamicFieldsInRow(type48FieldId, rowIndex);
    // showDynamicFields puede limpiar un control que estaba deshabilitado; se reescribe ya visible.
    for (const pair of cfg.copyActiveOption || []) {
      this.copyActiveOptionIntoRow(pair, sourceGroup, sourceRow, targetGroup, targetRow);
    }
    this.reevaluateAllDynamicFieldsInRow(type48FieldId, rowIndex);
    this.cdr.detectChanges();
  }

  private controlRawValue(ctrl: AbstractControl | null): unknown {
    if (!ctrl) return '';
    return typeof (ctrl as any).getRawValue === 'function' ? (ctrl as any).getRawValue() : ctrl.value;
  }

  private writeControlValue(ctrl: AbstractControl | null, value: unknown): void {
    if (!ctrl) return;
    if (ctrl.disabled) {
      ctrl.enable({ emitEvent: false });
    }
    const next = value == null ? '' : value;
    try {
      ctrl.setValue(typeof next === 'object' ? JSON.parse(JSON.stringify(next)) : next, { emitEvent: false });
    } catch {
      ctrl.setValue(next as any, { emitEvent: false });
    }
  }

  /** Copia el select (tipo de documento) y el número de la opción activa. */
  private copyActiveOptionIntoRow(
    pair: any,
    sourceGroup: any,
    sourceRow: FormGroup,
    targetGroup: any,
    targetRow: FormGroup
  ): void {
    const fromField = this.childByName(sourceGroup, pair.from);
    const toField = this.childByName(targetGroup, pair.to);
    if (!fromField || !toField) return;
    if (typeof fromField.values === 'string') {
      try { fromField.values = JSON.parse(fromField.values); } catch { /* sigue */ }
    }
    if (typeof toField.values === 'string') {
      try { toField.values = JSON.parse(toField.values); } catch { /* sigue */ }
    }
    const sourceOptionName = String(this.controlRawValue(this.rowControl(sourceRow, fromField.id)) ?? '');
    if (!sourceOptionName) return;
    const targetOptionName = resolveTargetOptionName(pair, sourceOptionName);
    this.writeControlValue(this.rowControl(targetRow, toField.id), targetOptionName);

    const sourceOption = (fromField.values || []).find((opt) => opt && opt.name === sourceOptionName);
    const targetOption = (toField.values || []).find((opt) => opt && opt.name === targetOptionName);
    const sourceChild = this.childByName(sourceGroup, optionChildName(sourceOption));
    const targetChild = pair.numberTo
      ? this.childByName(targetGroup, pair.numberTo)
      : this.childByName(targetGroup, optionChildName(targetOption));
    if (!sourceChild || !targetChild) return;
    this.writeControlValue(
      this.rowControl(targetRow, targetChild.id),
      this.controlRawValue(this.rowControl(sourceRow, sourceChild.id)) ?? ''
    );
  }

  private clampSourceIndex(cfg: any, field: any, targetGroup: any, targetRow: FormGroup, count: number): number | null {
    const indexName = cfg.sourceIndexField || field?.name;
    const indexField = indexName ? this.childByName(targetGroup, indexName) : null;
    const indexCtrl = indexField ? targetRow.controls[indexField.id] : null;
    const raw = indexCtrl ? indexCtrl.value : '0';
    if (cfg.allowOther && String(raw) === (cfg.otherValue || 'otro')) return null;
    let index = parseInt(raw, 10);
    if (!Number.isFinite(index) || index < 0 || index >= count) index = 0;
    if (indexCtrl && String(indexCtrl.value) !== String(index)) {
      indexCtrl.setValue(String(index), { emitEvent: false });
    }
    return index;
  }

  private copiedControlIds(cfg: any, targetGroup: any, row: FormGroup): Array<number | string> {
    const ids: Array<number | string> = [];
    for (const pair of cfg.map || []) {
      const to = this.childByName(targetGroup, pair.to);
      if (to) ids.push(to.id);
    }
    for (const pair of cfg.copyActiveOption || []) {
      const to = this.childByName(targetGroup, pair.to);
      if (!to) continue;
      ids.push(to.id);
      if (pair.numberTo) {
        const numberField = this.childByName(targetGroup, pair.numberTo);
        if (numberField) ids.push(numberField.id);
      } else {
        const optionName = row.controls[to.id]?.value;
        const option = (to.values || []).find((item) => item && item.name === optionName);
        const child = this.childByName(targetGroup, optionChildName(option));
        if (child) ids.push(child.id);
      }
    }
    return ids;
  }

  /** Destinos de la copia, incluidos todos los números de documento posibles. */
  private allCopyTargetIds(cfg: any, targetGroup: any): Array<number | string> {
    const ids: Array<number | string> = [];
    for (const pair of cfg.map || []) {
      const to = this.childByName(targetGroup, pair.to);
      if (to) ids.push(to.id);
    }
    for (const pair of cfg.copyActiveOption || []) {
      const to = this.childByName(targetGroup, pair.to);
      if (!to) continue;
      ids.push(to.id);
      if (pair.numberTo) {
        const numberField = this.childByName(targetGroup, pair.numberTo);
        if (numberField) ids.push(numberField.id);
      }
      for (const option of to.values || []) {
        const child = this.childByName(targetGroup, optionChildName(option));
        if (child) ids.push(child.id);
      }
    }
    return ids;
  }

  private clearControlValue(ctrl: any): void {
    if (!ctrl) return;
    if (ctrl instanceof FormArray) {
      const first = ctrl.at(0) as FormGroup;
      if (first?.controls?.seleccion) {
        first.controls['seleccion'].setValue('', { emitEvent: false });
        const sub = first.controls['sub'];
        if (sub instanceof FormArray) {
          while (sub.length) sub.removeAt(0);
        }
      } else {
        ctrl.reset([], { emitEvent: false });
      }
      return;
    }
    if (ctrl instanceof FormGroup) {
      Object.keys(ctrl.controls).forEach((key) => this.clearControlValue(ctrl.controls[key]));
      return;
    }
    const value = ctrl.value;
    if (typeof value === 'boolean') {
      ctrl.setValue(false, { emitEvent: false });
    } else {
      ctrl.setValue('', { emitEvent: false });
    }
  }

  private clearCopiedFieldValues(field: any, type48FieldId: number, rowIndex: number): void {
    const cfg = readCopyFromGroup(field);
    const targetGroup = (this.fields || []).find((item) => item && item.id === type48FieldId && item.type === 48);
    const row = this.type48Row(type48FieldId, rowIndex);
    if (!cfg || !targetGroup || !row) return;
    for (const id of this.allCopyTargetIds(cfg, targetGroup)) {
      const ctrl = row.controls[id];
      if (!ctrl) continue;
      this.clearControlValue(ctrl);
      (ctrl as any).copyLocked = false;
      delete (ctrl as any)._copyLockValue;
    }
    if (cfg.sourceIndexField) {
      const indexField = this.childByName(targetGroup, cfg.sourceIndexField);
      const indexCtrl = indexField ? row.controls[indexField.id] : null;
      if (indexCtrl) indexCtrl.setValue('', { emitEvent: false });
    }
    this.reevaluateAllDynamicFieldsInRow(type48FieldId, rowIndex);
    this.cdr.detectChanges();
  }

  private clearCopyLocks(field: any, type48FieldId: number, rowIndex: number): void {
    const cfg = readCopyFromGroup(field);
    const targetGroup = (this.fields || []).find((item) => item && item.id === type48FieldId && item.type === 48);
    const row = this.type48Row(type48FieldId, rowIndex);
    if (!cfg || !targetGroup || !row) return;
    for (const id of this.allCopyTargetIds(cfg, targetGroup)) {
      const ctrl = row.controls[id];
      if (ctrl) {
        (ctrl as any).copyLocked = false;
        delete (ctrl as any)._copyLockValue;
      }
    }
    this.cdr.detectChanges();
  }

  private applyAutoCopyLocks(type48Field: any, rowIndex: number): void {
    const cfg = readCopyFromGroup(type48Field);
    const row = this.type48Row(type48Field?.id, rowIndex);
    if (!cfg?.auto || cfg.lockCopied === false || !row) return;
    for (const id of this.allCopyTargetIds(cfg, type48Field)) {
      const ctrl = row.controls[id];
      if (!ctrl) continue;
      (ctrl as any).copyLocked = true;
      (ctrl as any)._copyLockValue = ctrl.value;
    }
  }

  /** Copia automática (p. ej. Beneficiario Final desde Datos Sociedad). */
  private syncAutoCopyFromGroups(): void {
    for (const group of this.fields || []) {
      if (!group || group.type !== 48) continue;
      const cfg = readCopyFromGroup(group);
      if (!cfg?.auto) continue;
      const arr = this.formCustomFields?.controls?.[group.id] as FormArray;
      if (!arr) continue;
      for (let index = 0; index < arr.length; index++) {
        this.copyFromGroupIntoRow(group, group.id, index);
        this.applyAutoCopyLocks(group, index);
      }
    }
    if (this.cdr) this.cdr.detectChanges();
  }

  private syncCopyLocksForRow(type48FieldId: number, rowIndex: number): void {
    const targetGroup = (this.fields || []).find((item) => item && item.id === type48FieldId && item.type === 48);
    const row = this.type48Row(type48FieldId, rowIndex);
    if (!targetGroup || !row) return;
    for (const child of targetGroup.customfields || []) {
      const cfg = readCopyFromGroup(child);
      if (!cfg || cfg.lockCopied === false) continue;
      const raw = row.controls[child.id]?.value;
      const locked = cfg.allowOther ? isSourceIndex(raw) : isCheckedValue(raw);
      for (const id of this.copiedControlIds(cfg, targetGroup, row)) {
        const ctrl = row.controls[id];
        if (!ctrl) continue;
        (ctrl as any).copyLocked = locked;
        if (locked) (ctrl as any)._copyLockValue = ctrl.value;
      }
    }
    this.applyAutoCopyLocks(targetGroup, rowIndex);
    this.syncCopyCheckboxAvailability(type48FieldId, rowIndex);
  }

  private syncCopyCheckboxAvailability(type48FieldId: number, rowIndex: number): void {
    const targetGroup = (this.fields || []).find((item) => item && item.id === type48FieldId && item.type === 48);
    const row = this.type48Row(type48FieldId, rowIndex);
    if (!targetGroup || !row) return;
    for (const child of targetGroup.customfields || []) {
      const cfg = readCopyFromGroup(child);
      if (!cfg || child.type !== 4) continue;
      const ctrl = row.controls[child.id];
      if (!ctrl) continue;
      const source = this.findType48ByName(cfg.sourceGroup);
      const sourceArray = source ? this.formCustomFields.controls[source.id] as FormArray : null;
      const count = sourceArray?.length || 0;
      const checked = isCheckedValue(ctrl.value);
      const indexField = cfg.sourceIndexField ? this.childByName(targetGroup, cfg.sourceIndexField) : null;
      const indexCtrl = indexField ? row.controls[indexField.id] : null;
      if (indexCtrl && (indexCtrl.value === '' || indexCtrl.value == null) && count > 0) {
        indexCtrl.setValue('0', { emitEvent: false });
      }
      if (count === 0) {
        if (checked) {
          ctrl.setValue(false, { emitEvent: false });
          this.clearCopyLocks(child, type48FieldId, rowIndex);
        }
        if (!ctrl.disabled) ctrl.disable({ emitEvent: false });
        (ctrl as any)._copyBlockedNoSource = true;
      } else if ((ctrl as any)._copyBlockedNoSource && ctrl.disabled) {
        ctrl.enable({ emitEvent: false });
        (ctrl as any)._copyBlockedNoSource = false;
      }
    }
  }

  private syncAllCopyCheckboxes(): void {
    for (const field of this.fields || []) {
      if (!field || field.type !== 48) continue;
      const arr = this.formCustomFields?.controls?.[field.id] as FormArray;
      if (!arr) continue;
      for (let index = 0; index < arr.length; index++) {
        this.syncCopyCheckboxAvailability(field.id, index);
      }
    }
    this.syncAutoCopyFromGroups();
  }

  addRepeat(e, field, index, isUserAdd = false) {
    let value;
    let subGroupCustomfields = {};

    const formArray = this.formCustomFields.controls[index] as FormArray;
    if (!formArray) return;

    // Reconstruir filas preservadas SOLO en la carga inicial (al navegar hacia atras).
    // En un click del boton "+" (isUserAdd) el usuario siempre quiere una fila NUEVA vacia:
    // no re-entrar aqui evita (a) duplicar las filas preservadas y (b) marcar la fila nueva
    // como preservada, lo que le negaria su defaultvalue.
    if (!isUserAdd && field.value != '' && field.value != null && field._hasPreservedValue && !this.edit) {
      try {
        let data = typeof field.value === 'string' ? JSON.parse(field.value) : field.value;
        this.repeatList[index] = formArray;

        const subFieldsPreserved = field.customfields || [];
        data.forEach((element, key) => {
          subGroupCustomfields = this.getDefinitionCustomfields(subFieldsPreserved, value, false);

          Object.keys(element).forEach((fieldIdStr) => {
            const fieldIdNum = parseInt(fieldIdStr, 10);
            const fieldValue = element[fieldIdStr];
            const foundField = subFieldsPreserved.find((cf: any) =>
              cf.id == fieldIdNum || cf.id == fieldIdStr || cf.id.toString() == fieldIdStr
            );

            if (foundField && subGroupCustomfields[foundField.id]) {
              if (foundField.type === 14 && Array.isArray(fieldValue) && fieldValue.length > 0) {
                const type14FormArray = subGroupCustomfields[foundField.id] as FormArray;
                if (type14FormArray && type14FormArray.controls.length > 0) {
                  const type14FormGroup = type14FormArray.controls[0] as FormGroup;
                  if (type14FormGroup) {
                    const savedValue = fieldValue[0];
                    const processedSelected = this.formatAppTreeForEdit(foundField, savedValue);
                    foundField.selected = processedSelected;
                    if (savedValue.seleccion !== undefined) {
                      type14FormGroup.patchValue({ seleccion: savedValue.seleccion });
                    }
                    if (savedValue.sub && Array.isArray(savedValue.sub) && savedValue.sub.length > 0) {
                      const subFormArray = type14FormGroup.get('sub') as FormArray;
                      if (subFormArray) {
                        while (subFormArray.length > 0) {
                          subFormArray.removeAt(0);
                        }
                        savedValue.sub.forEach((subItem: any) => {
                          subFormArray.push(this.fb.group(subItem));
                        });
                      }
                    }
                  }
                }
              } else {
                let processedValue = fieldValue;
                if (typeof fieldValue === 'string' && fieldValue.startsWith('"') && fieldValue.endsWith('"')) {
                  try {
                    processedValue = JSON.parse(fieldValue);
                  } catch (e) {
                    processedValue = fieldValue;
                  }
                }
                if (Array.isArray(processedValue)) {
                  processedValue = processedValue.length === 0 ? '' : (processedValue.length === 1 ? (processedValue[0] === '' ? '' : processedValue[0]) : processedValue[0]);
                }
                subGroupCustomfields[foundField.id][0] = processedValue;
              }
            }
          });
          console.log('this.repeatList[index]>>>>',this.repeatList)
          const preservedRowGroup = this.createSubGroup(subGroupCustomfields);
          // Marcar la fila como reconstruida desde un snapshot preservado. Este flag vive
          // en el FormGroup de la fila (no en el field48 compartido), asi distingue una
          // fila restaurada de una fila nueva agregada despues por el usuario.
          (preservedRowGroup as any)._preservedRow = true;
          this.repeatList[index].push(preservedRowGroup);
        });

        setTimeout(() => {
          data.forEach((element, key) => {
            this.initializeDynamicFieldsInType48Row(field.id, key);
          });
          this.syncAllCopyCheckboxes();
        }, 100);
      } catch (error) {
        // Si falla, crear fila vacía (comportamiento original)
        subGroupCustomfields = this.getDefinitionCustomfields(field.customfields || [], value, false);
        this.repeatList[index] = formArray;
        const newRowIndex = this.repeatList[index].length;
        this.repeatList[index].push(this.createSubGroup(subGroupCustomfields));
        setTimeout(() => {
          this.initializeDynamicFieldsInType48Row(field.id, newRowIndex);
          this.syncAllCopyCheckboxes();
        }, 1000);
      }
    } else {
      // Comportamiento original: crear fila vacía
      subGroupCustomfields = this.getDefinitionCustomfields(field.customfields || [], value, false);
      this.repeatList[index] = formArray;
      const newRowIndex = this.repeatList[index].length;
      this.repeatList[index].push(this.createSubGroup(subGroupCustomfields));
      this.syncAllCopyCheckboxes();
      setTimeout(() => {
        this.initializeDynamicFieldsInType48Row(field.id, newRowIndex);
        this.syncAllCopyCheckboxes();
      }, 1000);
    }
  }

  editRepeat(field, index) {
    let value;
    let subGroupCustomfields = {};
    if (field.value != '' && field.value != null) {
      try {
        const formArray = this.formCustomFields?.controls?.[index] as FormArray;
        if (!formArray || !(formArray instanceof FormArray)) {
          return;
        }
        this.repeatList[index] = formArray;

        let data = JSON.parse(field.value);
        const subFields = field.customfields || field.values || [];
        data.forEach((element, key) => {
          // Crear la estructura del FormGroup con los campos de la agrupación
          subGroupCustomfields = this.getDefinitionCustomfields(subFields, value, this.edit);

          // Mapear los valores guardados (usando IDs como claves) a los campos del FormGroup
          // Los IDs en el JSON pueden ser strings, pero en customfields son números
          Object.keys(element).forEach((fieldIdStr) => {
            const fieldIdNum = parseInt(fieldIdStr, 10);
            const fieldValue = element[fieldIdStr];

            // Buscar el campo en customfields/values (cf.id puede ser undefined en algunos values)
            const foundField = subFields.find((cf: any) =>
              cf && cf.id != null && (cf.id == fieldIdNum || cf.id == fieldIdStr || String(cf.id) === fieldIdStr)
            );

            if (foundField) {
              // Usar el ID del campo encontrado (puede ser número o string, JavaScript lo maneja)
              const correctId = foundField.id;
              if (subGroupCustomfields[correctId]) {
                // Para campos tipo 14 (nested selects), el valor es un array con estructura específica
                if (foundField.type === 14 && Array.isArray(fieldValue) && fieldValue.length > 0) {
                  // fieldValue es un array como [{"seleccion": "1", "sub": [{"seleccion1": "101"}]}]
                  // subGroupCustomfields[correctId] es directamente un FormArray (no un array que contiene FormArray)
                  const type14FormArray = subGroupCustomfields[correctId] as FormArray;

                  if (type14FormArray && type14FormArray.controls.length > 0) {
                    const type14FormGroup = type14FormArray.controls[0] as FormGroup;

                    if (type14FormGroup) {
                      const savedValue = fieldValue[0]; // Tomar el primer elemento

                      // Procesar el valor para crear field.selected que necesita setAppTree()
                      const processedSelected = this.formatAppTreeForEdit(foundField, savedValue);
                      foundField.selected = processedSelected;

                      // Actualizar el FormGroup con los valores guardados
                      if (savedValue.seleccion !== undefined) {
                        type14FormGroup.patchValue({ seleccion: savedValue.seleccion });
                      }

                      // Manejar el FormArray 'sub' si existe
                      if (savedValue.sub && Array.isArray(savedValue.sub) && savedValue.sub.length > 0) {
                        const subFormArray = type14FormGroup.get('sub') as FormArray;
                        if (subFormArray) {
                          // Limpiar el FormArray sub si tiene elementos
                          while (subFormArray.length > 0) {
                            subFormArray.removeAt(0);
                          }
                          // Agregar los valores guardados al FormArray sub
                          savedValue.sub.forEach((subItem: any, subIndex: number) => {
                            const subFormGroup = this.fb.group(subItem);
                            subFormArray.push(subFormGroup);
                          });
                        }
                      }
                    }
                  }
                } else {
                  // Para otros tipos de campos, asignar el valor directamente
                  // Si el valor es un string JSON (empieza y termina con comillas), parsearlo
                  let processedValue = fieldValue;
                  if (typeof fieldValue === 'string' && fieldValue.startsWith('"') && fieldValue.endsWith('"')) {
                    try {
                      processedValue = JSON.parse(fieldValue);
                    } catch (e) {
                      // Si falla el parseo, usar el valor original
                      processedValue = fieldValue;
                    }
                  }

                  // Normalizar arrays: si el valor es un array, convertirlo a su primer elemento
                  // Esto es especialmente importante para campos dinámicos que pueden venir como [""] desde la BD
                  if (Array.isArray(processedValue)) {
                    if (processedValue.length === 0) {
                      processedValue = '';
                    } else if (processedValue.length === 1) {
                      processedValue = processedValue[0] === '' ? '' : processedValue[0];
                    } else {
                      // Si tiene múltiples elementos, tomar el primero
                      processedValue = processedValue[0];
                    }
                  }

                  subGroupCustomfields[correctId][0] = processedValue;
                }
              }
            }
          });

          this.repeatList[index].push(this.createSubGroup(subGroupCustomfields));
        });

        // Inicializar campos dinámicos tipo 6 en cada fila después de cargar los datos
        // Usar un delay para asegurar que Angular haya procesado los cambios en el FormGroup
        setTimeout(() => {
          data.forEach((element, key) => {
            this.initializeDynamicFieldsInType48Row(field.id, key);
          });
          this.syncAllCopyCheckboxes();
        }, 100);
      } catch (error) {
        console.error('Error parsing field.value in editRepeat:', error, field);
      }
    }
  }

  /**
   * Procesa el valor de un campo tipo 14 para crear la estructura field.selected
   * Similar a formatAppTree pero para uso en editRepeat
   * @param field Campo tipo 14
   * @param savedValue Valor guardado del campo
   */
  formatAppTreeForEdit(field: any, savedValue: any): any[] {
    const selected: any[] = [];
    let indexMemory: number;
    this.ensureType14TreeValues(field);
    const seleccionId = this.coerceType14Scalar(savedValue?.seleccion);

    if (savedValue && field.values && Array.isArray(field.values)) {
      // Buscar la selección del primer nivel
      field.values.forEach((element: any, index: number) => {
        if (seleccionId && String(seleccionId) === String(element.id)) {
          selected.push({
            nivel: 1,
            seleccion: String(element.id),
            name: element.name,
            nameSub: element.nameSub || element.sub?.[0]?.nameSub || ''
          });
          indexMemory = index;
        }
      });

      const subSelections = this.extractType14SelectionsFromSub(savedValue.sub);
      for (const sel of subSelections) {
        selected.push({
          nivel: sel.nivel,
          seleccion: String(sel.seleccion),
          name: '',
          nameSub: '',
        });
      }
    }

    // Obtener los nombres de las selecciones anidadas navegando por la estructura
    let newSub = null;
    if (indexMemory !== undefined && field.values[indexMemory]) {
      newSub = field.values[indexMemory].sub;
    }

    // Para cada selección anidada, buscar su nombre correspondiente
    for (let i = 1; i < selected.length; i++) {
      if (newSub && Array.isArray(newSub)) {
        let comparationSub = newSub;
        let foundIndex = -1;

        comparationSub.forEach((element: any, index: number) => {
          if (String(selected[i].seleccion) === String(element.id)) {
            selected[i].name = element.name;
            selected[i].nameSub = element.nameSub || element.sub?.[0]?.nameSub || '';
            foundIndex = index;
          }
        });

        // Navegar al siguiente nivel si existe
        if (foundIndex >= 0 && comparationSub[foundIndex] && comparationSub[foundIndex].sub != undefined) {
          newSub = comparationSub[foundIndex].sub;
        } else {
          // Si no hay más niveles, no continuar navegando
          newSub = null;
        }
      }
    }

    return selected.filter(
      (option: any) => option.seleccion != null && option.seleccion !== ''
    );
  }

  private coerceType14Scalar(v: unknown): string {
    if (v == null || v === '') {
      return '';
    }
    if (Array.isArray(v)) {
      const first = v.find((x) => x != null && x !== '');
      return first != null ? String(first) : '';
    }
    return String(v);
  }

  /**
   * Normaliza sub: [{seleccion1:55, seleccion2:3}] o [{seleccion1:55},{seleccion2:3}]
   * → [{seleccion1:55},{seleccion2:3}] (un control de formulario por nivel).
   */
  private normalizeType14SubArray(sub: unknown): Array<Record<string, string | number>> {
    if (!Array.isArray(sub)) {
      return [];
    }
    const out: Array<Record<string, string | number>> = [];
    for (const entry of sub) {
      if (!entry || typeof entry !== 'object') {
        continue;
      }
      const keys = Object.keys(entry)
        .filter((k) => /^seleccion\d+$/.test(k))
        .sort(
          (a, b) =>
            parseInt(a.replace('seleccion', ''), 10) - parseInt(b.replace('seleccion', ''), 10)
        );
      if (keys.length === 0) {
        out.push(entry as Record<string, string | number>);
        continue;
      }
      for (const key of keys) {
        const scalar = this.coerceType14Scalar(entry[key]);
        if (scalar !== '') {
          out.push({ [key]: scalar });
        }
      }
    }
    return out;
  }

  private extractType14SelectionsFromSub(
    sub: unknown
  ): Array<{ nivel: number; seleccion: number }> {
    return this.normalizeType14SubArray(sub).map((entry) => {
      const key =
        Object.keys(entry).find((k) => /^seleccion\d+$/.test(k)) || 'seleccion1';
      const level = parseInt(key.replace('seleccion', ''), 10);
      return {
        nivel: level + 1,
        seleccion: parseInt(String(entry[key]), 10),
      };
    });
  }

  private parseType14SavedValue(value: unknown): Record<string, unknown> | null {
    if (value == null || value === '') {
      return null;
    }
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      } catch {
        return null;
      }
    }
    if (Array.isArray(value)) {
      return value[0] ?? null;
    }
    if (typeof value === 'object') {
      return value as Record<string, unknown>;
    }
    return null;
  }

  private ensureType14TreeValues(field: { id?: number | string; values?: unknown }): void {
    if (typeof field.values === 'string') {
      try {
        field.values = JSON.parse(field.values);
        const idx = (this.counterTree || []).findIndex(
          (c: { id?: number | string }) => String(c?.id) === String(field.id)
        );
        if (idx >= 0) {
          this.nestedValues[idx] = field.values as never;
        }
      } catch {
        /* tree inválido */
      }
    }
  }

  /** Edición: field.selected + árbol parseado para app-tree-select (región/comuna). */
  private hydrateType14FieldsForEdit(): void {
    this.fields.forEach((field: any) => {
      if (field.type !== 14 || field.value == null || field.value === '') {
        return;
      }
      this.ensureType14TreeValues(field);
      const fieldValue = this.parseType14SavedValue(field.value);
      if (fieldValue?.sub) {
        fieldValue.sub = this.normalizeType14SubArray(fieldValue.sub);
      }
      if (
        fieldValue &&
        fieldValue.seleccion !== undefined &&
        field.values &&
        Array.isArray(field.values)
      ) {
        field.selected = this.formatAppTreeForEdit(field, fieldValue);
      }
    });
  }

  removeRepeat(field, index) {
    const confirmModal = this.modalService.open(ConfirmActionModalComponent, { size: 'sm', centered: true });
    confirmModal.componentInstance.titel = `Eliminar ${(field.alias.split(' '))[1]}`;
    confirmModal.componentInstance.message = `¿Está seguro de eliminar el ${((field.alias.split(' ')).length > 1) ? (field.alias.split(' '))[1].toLowerCase() : field.alias.split(' ')[0].toLowerCase()} # ${index + 1}?`;
    confirmModal.result.then((confirmed) => {
      if (confirmed) {
        this.repeatList[field.id].removeAt(index);
        this.refreshType48VisibilityAfterRowRemoved(field.id);
        this.syncAllCopyCheckboxes();

        this.customfieldsValues.emit(this.formCustomFields);
      }
    }).catch();
  }

  initInputCollection(type, value) {
    let newValue: { seleccion?: string | number; sub?: unknown } = { seleccion: '' };
    if (value && value !== '') {
      if (this.isJson(value)) {
        const tempValue = JSON.parse(value);
        if (tempValue?.[0]) {
          newValue = tempValue[0];
        }
      } else if (Array.isArray(value) && value[0]) {
        newValue = value[0];
      }
    }
    const normalizedSub = this.edit ? this.normalizeType14SubArray(newValue.sub) : [];
    const subGroups = normalizedSub.map((subItem) => {
      const flat: Record<string, string> = {};
      for (const [k, v] of Object.entries(subItem)) {
        flat[k] = String(v);
      }
      return this.fb.group(flat);
    });
    return this.fb.group({
      seleccion: [this.coerceType14Scalar(newValue.seleccion)],
      sub: this.fb.array(this.edit && subGroups.length ? subGroups : []),
    });
  }

  initInputCollection55(value) {
    let newValue = null;
    let tempValue = null;
    if (value && value != "" && this.isJson(value)) {
      tempValue = JSON.parse(value);
    }
    newValue = tempValue ? tempValue[0] : { seleccion: "", sub: [{ seleccion1: "" }], sub2: [{ seleccion2_1: "" }] };
    return this.fb.group({
      seleccion: [newValue.seleccion || ""],
      sub: this.fb.array([]),
      sub2: this.fb.array([])
    });
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.fields || !changes.fields.previousValue) {
      return;
    }
    const current = changes.fields.currentValue;
    const previous = changes.fields.previousValue;
    if (
      !Array.isArray(current) ||
      !Array.isArray(previous) ||
      current.length === 0 ||
      previous.length === 0 ||
      current[0]?.id == null ||
      previous[0]?.id == null
    ) {
      return;
    }
    if (current[0].id !== previous[0].id) {
      this.ngOnInit();
    }
  }

  /** model JSON en BD (common.counterparty). */
  private parseFieldModel(field: any): Record<string, unknown> | null {
    if (!field) {
      return null;
    }
    if (field.modelParsed && typeof field.modelParsed === 'object') {
      return field.modelParsed;
    }
    const raw = field.model;
    if (raw == null || raw === '') {
      return null;
    }
    if (typeof raw === 'object') {
      field.modelParsed = raw;
      return raw;
    }
    const s = String(raw).trim();
    if (!s) {
      return null;
    }
    try {
      field.modelParsed = s.startsWith('{') ? JSON.parse(s) : { query: s };
    } catch {
      field.modelParsed = { query: s };
    }
    return field.modelParsed;
  }

  private getCommonCounterpartyChildFields(parentField: any): any[] {
    if (!parentField?.name || !Array.isArray(this.fields)) {
      return [];
    }
    return this.fields.filter((f) => {
      const m = this.parseFieldModel(f);
      return m?.['dependsOn'] === parentField.name;
    });
  }

  private async loadModelOptionsForField(childField: any, parentValue: any): Promise<void> {
    if (!childField?.id || parentValue == null || parentValue === '') {
      childField.values = [];
      return;
    }
    try {
      const resp: any = await firstValueFrom(
        this._customfields.postModelOptions({
          customfieldId: childField.id,
          parentValue,
        })
      );
      const payload = resp?.result ?? resp;
      childField.values = payload?.values ?? [];
    } catch (err) {
      console.warn('[customfields] model-options:', childField?.name, err);
      childField.values = [];
    }
  }

  private initCommonCounterpartyCascade(): void {
    if (!this.formCustomFields || !Array.isArray(this.fields)) {
      return;
    }
    for (const f of this.fields) {
      const m = this.parseFieldModel(f);
      if (!m?.['dependsOn']) {
        continue;
      }
      const parent = this.fields.find((p) => p.name === m['dependsOn']);
      if (!parent?.id) {
        continue;
      }
      const parentVal =
        this.formCustomFields.get(String(parent.id))?.value ??
        extractType52Id(parent?.value) ??
        parent?.value;
      if (parentVal != null && parentVal !== '') {
        void this.loadModelOptionsForField(f, parentVal).then(() => this.cdr.markForCheck());
      }
    }
  }

  /** País type 6: Región/Comuna (por nombre o ids 100000/100001) solo si el valor es Chile. */
  private chileLocationControlIds(): string[] {
    const named = ['Región', 'Comuna']
      .map((n) => this.fields?.find((f: any) => f.name === n && f.id !== 100000 && f.id !== 100001))
      .filter(Boolean)
      .map((f: any) => String(f.id));
    if (named.length) {
      return named;
    }
    return ['100000', '100001'];
  }

  private syncChileLocationFields(selectedCountry: unknown): void {
    if (!this.formCustomFields) {
      return;
    }
    const hasScdPaisType6 = this.fields?.some((f: any) => f.type === 6 && f.name === 'País');
    if (!hasScdPaisType6) {
      return;
    }
    const isChile = String(selectedCountry ?? '').trim() === 'Chile';
    for (const id of this.chileLocationControlIds()) {
      const field = this.fields?.find((f: any) => String(f.id) === id);
      if (field) {
        field.hidden = !isChile;
        field.required = isChile;
      }
      const control = this.formCustomFields.controls[id];
      if (!control) {
        continue;
      }
      if (isChile) {
        control.enable({ emitEvent: false });
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
        control.setValue('', { emitEvent: false });
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
      }
    }
  }

  private async handleCommonCounterpartyParentChange(parentField: any, parentValue: any): Promise<void> {
    const children = this.getCommonCounterpartyChildFields(parentField);
    for (const child of children) {
      const ctrl = this.formCustomFields?.get(String(child.id));
      if (ctrl) {
        ctrl.setValue('');
        ctrl.markAsDirty();
      }
      child.values = [];
      if (parentValue != null && parentValue !== '') {
        await this.loadModelOptionsForField(child, parentValue);
      }
    }
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.teardownComputedRulesSubscriptions();
  }

  private teardownComputedRulesSubscriptions(): void {
    if (this.computedRulesSubscription) {
      this.computedRulesSubscription.unsubscribe();
      this.computedRulesSubscription = null;
    }
  }

  /**
   * Motor genérico: lee JSON en `computed_rules` de cualquier customfield del grupo,
   * recalcula targets al cambiar los disparadores (`when` o fuentes inferidas).
   */
  private setupComputedRulesSubscriptions(): void {
    this.teardownComputedRulesSubscriptions();
    if (!this.formCustomFields) return;

    const doc = collectMergedRulesFromFields(this.fields);
    if (!doc) return;

    const triggerNames = collectTriggerFieldNames(doc);
    const streams = [];
    for (const name of triggerNames) {
      const meta = findFieldByExactFieldName(this.fields, name);
      if (!meta) continue;
      const c = this.formCustomFields.get(String(meta.id));
      if (!c) continue;
      streams.push(c.valueChanges.pipe(startWith(c.value)));
    }

    const run = () => {
      if (!this.formCustomFields) return;
      executeComputedRules(this.formCustomFields, this.fields, doc);
      this.cdr?.markForCheck();
    };

    if (streams.length === 0) {
      run();
      return;
    }

    this.computedRulesSubscription = merge(...streams)
      .pipe(debounceTime(0))
      .subscribe(() => run());
  }

  setValueAndTermino(value) {
    let numbValue = Number(value);
    this.formCustomFields.controls[this.itemId]["controls"]["cuantia_$"].value =
      numbValue;
    this.fieldIsNotEmpty["cuantia"] = true;
  }

  deleteItem({ id, index }) {
    (this.formCustomFields.controls[id] as FormArray).removeAt(index);
    this.onChange();
  }

  addItem(id: number) {
    (this.formCustomFields.controls[id] as FormArray).push(
      this.fb.group({ parent: "", child: "" })
    );
    this.onChange();
  }

  onValueChange({ event, name, index }) {
    this.fieldIsNotEmpty[name + index] = !!event;
    this.onChange();

    // setTimeout(() => {
    //   this.onChange();
    // }, 500);
  }

  onValueChange50(id: number) {
    this.isComuna ? this.setValuesComuna(id) : this.setValuesStore(id);
    // setTimeout(() => {
    //   this.onChange();
    // }, 500);
  }

  setValuesComuna(value) {
    this.comuna.changeOption(value);
  }

  setValuesStore(value) {
    this.areaService.changeOption(value);
  }

  onValueChange26({ event, field, index }) {
    field.child_items[index] = field.items.find((f) => f.value == event).items;
    this.fieldIsNotEmpty[field.parent_name + index] = !!event;

    this.onChange();
    // setTimeout(() => {
    //   this.onChange();
    // }, 500);
  }

  getItem24Values({ event, name }) {
    this.fieldIsNotEmpty[name] = !!event;
    // this is the logical for the form "Termino"
    let monto_ahorrado =
      this.formCustomFields.controls[this.itemId]["controls"]["cuantia_$"]
        .value -
      this.formCustomFields.controls[this.itemId]["controls"]["monto_pagado_$"]
        .value;
    let porcent_ahorrado = (
      (monto_ahorrado /
        this.formCustomFields.controls[this.itemId]["controls"]["cuantia_$"]
          .value) *
      100
    ).toFixed(2);
    this.formCustomFields.controls[this.itemId]["controls"][
      "monto_ahorrado_$"
    ].value = monto_ahorrado;
    this.formCustomFields.controls[this.itemId]["controls"][
      "monto_ahorrado_$"
    ].setValue(monto_ahorrado);
    this.formCustomFields.controls[this.itemId]["controls"][
      "porcentaje_ahorrado"
    ].value = porcent_ahorrado;
    this.formCustomFields.controls[this.itemId]["controls"][
      "porcentaje_ahorrado"
    ].setValue(porcent_ahorrado);
    setTimeout(() => {
      this.onChange();
    }, 500);
  }

  async evaluaArimetica(fn) {
    return await new Function('return ' + fn)();
  }

  private normalizeFieldName(value?: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  findField(array?, name?, name2?) {
    if (!Array.isArray(array)) {
      return null;
    }
    const direct = array.find((x) => x && x.name == name) || array.find((x) => x && x.name == name2);
    if (direct) return direct;

    const n1 = this.normalizeFieldName(name);
    const n2 = this.normalizeFieldName(name2);
    return array.find((x: any) => {
      const candidate = this.normalizeFieldName(x?.name);
      return (n1 && candidate === n1) || (n2 && candidate === n2);
    }) || null;
  }

  /** option.values: string ("SEREMI") u objeto legacy { name, alias }. */
  private type6DynamicFieldName(entry: any): string | null {
    if (entry == null) return null;
    if (typeof entry === 'string') return entry.trim() || null;
    if (typeof entry === 'object' && entry.name != null) return String(entry.name).trim() || null;
    return null;
  }

  private type6OptionDynamicNames(values: any[]): string[] {
    return (values || [])
      .map((e) => this.type6DynamicFieldName(e))
      .filter((n): n is string => n != null);
  }

  private type6ListsField(parent: any, childName: string): boolean {
    if (parent && typeof parent.values === 'string') {
      try {
        parent.values = JSON.parse(parent.values);
      } catch {
        return false;
      }
    }
    if (!parent?.values || !Array.isArray(parent.values) || !childName) return false;
    return parent.values.some((opt) =>
      this.type6OptionDynamicNames(opt?.values || []).includes(childName)
    );
  }

  /**
   * Un tipo 6 anidado solo abre sus hijos si el tipo 6 padre lo está mostrando.
   * Si no, al cambiar de opción el hijo (p. ej. Número Documento) se queda visible.
   */
  private type6IsActiveInRow(type6Field: any, allType6Fields: any[], rowFormGroup: FormGroup, visiting?: Set<any>): boolean {
    if (!type6Field) return false;
    const seen = visiting || new Set<any>();
    if (seen.has(type6Field.id)) return false;
    seen.add(type6Field.id);

    const controllers = (allType6Fields || []).filter((other) =>
      other && other.id !== type6Field.id && this.type6ListsField(other, type6Field.name)
    );
    if (controllers.length === 0) return true;

    for (const parent of controllers) {
      if (!this.type6IsActiveInRow(parent, allType6Fields, rowFormGroup, seen)) continue;
      const parentValue = rowFormGroup.controls[parent.id]?.value;
      const selected = (parent.values || []).find((opt: any) => opt && opt.name === parentValue);
      if (selected && this.type6OptionDynamicNames(selected.values || []).includes(type6Field.name)) {
        return true;
      }
    }
    return false;
  }

  private applyType6ReplaceAlias(option: any, targetFields: any[]): void {
    if (!option?.replaceAlias || !option?.values?.length) return;
    const optionAlias =
      typeof option.alias === 'string' && option.alias.trim() !== '' ? option.alias.trim() : null;
    for (const entry of option.values) {
      const name = this.type6DynamicFieldName(entry);
      if (!name) continue;
      const foundField = this.findField(targetFields, name);
      if (!foundField) continue;
      if (optionAlias) {
        foundField.alias = optionAlias;
      } else if (typeof entry === 'object' && entry.alias != null && entry.alias !== '') {
        foundField.alias = entry.alias;
      }
    }
  }

  /**
   * Initialize alias fields: Para remplazar de forma dinamica los alias de los campos, soloaplica cambio para los select de tipo 6
   */
  initializeAliasFields() {

      const foundFields = this.customfieldsAlls.filter((field) => field.type == 6);
      for (const field of foundFields) {
        if (field && field.hasOwnProperty('values') && field.values.length > 0) {

          for (const optionValue of field.values) {
            if(optionValue.hasOwnProperty('replaceAlias')){
              if(optionValue.replaceAlias){
                if (optionValue.hasOwnProperty('values') && optionValue.values.length > 0) {
                  if (field.value && field.value == optionValue.name) {
                    this.applyType6ReplaceAlias(optionValue, this.fields);
                  }
                }
              }
            }
          }
        }
      }
    }

  /**
   * Initialize dynamic fields: Para mostrar los campos dinamicos, solo aplica para campos select de tipo 6
   */
  initializeDynamicFields() {

    const foundFields = this.fields.filter((field) => field.type == 6);
    const sourceFields = (this.fields && this.fields.length > 0) ? this.fields : this.filterFields;

    for (const field of foundFields) {
      if (typeof field.values === 'string') {
        try {
          field.values = JSON.parse(field.values);
        } catch {
          continue;
        }
      }
      if (field && field.hasOwnProperty('values') && field.values.length > 0) {
        // Inicializar el array de campos dinámicos para este campo tipo 6
        this.dynamicFields[field.id] = [];

        // Obtener el valor del campo desde el FormGroup si existe (para valores preservados al navegar)
        let fieldValue = field.value;
        if (this.formCustomFields && this.formCustomFields.controls[field.id]) {
          const formValue = this.formCustomFields.controls[field.id].value;
          // Si hay valor en el FormGroup y no hay en field.value, usar el del FormGroup
          if ((!fieldValue || fieldValue === '') && formValue !== null && formValue !== undefined && formValue !== '') {
            fieldValue = formValue;
          }
        }

        for (const optionValue of field.values) {
          if (optionValue.hasOwnProperty('values') && optionValue.values.length > 0) {

            if (fieldValue && fieldValue == optionValue.name) {
              for (const dynamicField of optionValue.values) {
                const dynamicName = this.type6DynamicFieldName(dynamicField);
                const foundField = dynamicName ? this.findField(sourceFields, dynamicName) : null;
                if (foundField) {

                  this.showDynamicFields(foundField, true);
                }
              }
              this.dynamicFields[field.id] = this.type6OptionDynamicNames(optionValue.values);
              this.applyType6ReplaceAlias(optionValue, sourceFields);
            } else {

              for (const dynamicField of optionValue.values) {
                const dynamicName = this.type6DynamicFieldName(dynamicField);
                const foundField = dynamicName ? this.findField(sourceFields, dynamicName) : null;
                if (foundField && !this.dynamicFields[field.id].includes(foundField.name)) {
                  this.showDynamicFields(foundField, false);
                }
              }
            }
          }
        }

        if (fieldValue) {
          this.syncType53FromType6Selection(field, fieldValue);
        }
      }
    }

    // Inicializar campos dinámicos dentro de tipo 48
    this.initializeDynamicFieldsInType48();
  }

  /**
   * Initialize dynamic fields dentro de tipo 48
   */
  initializeDynamicFieldsInType48() {
    // Buscar todos los campos tipo 48
    const type48Fields = this.fields.filter((field) => field.type == 48);

    for (const type48Field of type48Fields) {
      if (!type48Field.customfields || !Array.isArray(type48Field.customfields)) {
        continue;
      }

      // Obtener el FormArray del tipo 48
      const type48FormArray = this.formCustomFields.controls[type48Field.id] as FormArray;
      if (!type48FormArray) {
        continue;
      }

      // Procesar cada fila del FormArray usando la misma lógica de re-evaluación
      type48FormArray.controls.forEach((rowFormGroup: FormGroup, rowIndex: number) => {
        // Inicializar la estructura si no existe
        if (!this.dynamicFieldsType48[type48Field.id]) {
          this.dynamicFieldsType48[type48Field.id] = {};
        }
        if (!this.dynamicFieldsType48[type48Field.id][rowIndex]) {
          this.dynamicFieldsType48[type48Field.id][rowIndex] = {};
        }

        // Buscar campos tipo 6 dentro del tipo 48
        const type6Fields = type48Field.customfields.filter((field: any) => field.type == 6);

        // Inicializar registros para todos los campos tipo 6
        for (const type6Field of type6Fields) {
          if (type6Field && type6Field.hasOwnProperty('values') && Array.isArray(type6Field.values)) {
            if (!this.dynamicFieldsType48[type48Field.id][rowIndex][type6Field.id]) {
              this.dynamicFieldsType48[type48Field.id][rowIndex][type6Field.id] = [];
            }

            // Obtener el valor del campo tipo 6 en esta fila
            const type6Value = rowFormGroup.controls[type6Field.id]?.value;

            if (type6Value && type6Value !== '' && type6Value !== null) {
              // Buscar la opción seleccionada
              const selectedOption = type6Field.values.find((opt: any) => opt.name === type6Value);

              if (selectedOption && selectedOption.hasOwnProperty('values') && Array.isArray(selectedOption.values) && selectedOption.values.length > 0) {
                // Actualizar el registro con los campos dinámicos de esta opción
                this.dynamicFieldsType48[type48Field.id][rowIndex][type6Field.id] =
                  this.type6OptionDynamicNames(selectedOption.values);
              } else {
                // Si no tiene values, limpiar el registro
                this.dynamicFieldsType48[type48Field.id][rowIndex][type6Field.id] = [];
              }
            } else {
              // Si no hay valor, limpiar el registro
              this.dynamicFieldsType48[type48Field.id][rowIndex][type6Field.id] = [];
            }
          }
        }

        // Re-evaluar todos los campos dinámicos usando la lógica de combinación
        this.reevaluateAllDynamicFieldsInRow(type48Field.id, rowIndex);
      });
    }
  }

  /**
   * Show or hide dinamyc fiels
   * @param foundField
   * @param visible
   */
  showDynamicFields(foundField: any, visible: boolean) {
    
    // Guard: el formulario y el control deben existir (evita NG01002 y null reference)
    if (!this.formCustomFields || !this.formCustomFields.controls[foundField.id]) {
      const element: any = document.querySelector(`article[id="article-${foundField.id}"]`);
      if (element && element.style) {
        element.style.display = visible ? 'block' : 'none';
      }
      return;
    }

    const control = this.formCustomFields.controls[foundField.id];
    let valueField = '';

    if (visible) {
      // Primero verificar si ya existe un valor en el FormGroup (valores preservados al navegar)
      const existingValue = control.value;

      if (existingValue !== null && existingValue !== undefined && existingValue !== '') {
        // Normalizar arrays: si el valor es un array, convertirlo a su primer elemento
        if (Array.isArray(existingValue)) {
          if (existingValue.length === 0) {
            valueField = '';
          } else if (existingValue.length === 1) {
            valueField = existingValue[0] === '' ? '' : existingValue[0];
          } else {
            valueField = existingValue[0];
          }
        } else {
          valueField = existingValue;
        }
      } else if (this.edit && foundField.value) {
        // Si no hay valor en FormGroup pero estamos en modo edición y hay en foundField, usarlo
        valueField = foundField.value;
      } else if (foundField._hasPreservedValue && foundField.value) {
        // Si el campo tiene valor preservado (navegando hacia atrás), usarlo
        valueField = foundField.value;
      }
    }

    // Asegurarse de que valueField nunca sea un array
    if (Array.isArray(valueField)) {
      valueField = valueField.length > 0 ? (valueField[0] === '' ? '' : valueField[0]) : '';
    }

    // Solo setValue en FormControl: FormArray/FormGroup requieren array/objeto y provocan NG01002
    if (control instanceof FormControl) {
      control.setValue(valueField, { emitEvent: false });
    }

    if (foundField.type == 8) {
      if (visible) {
        control.enable({ emitEvent: false });
        control.setValidators(correctRutValidator());
      } else {
        control.clearValidators();
        // FormArray/FormGroup: clearValidators() solo quita validadores del contenedor;
        // la validez viene de los hijos. Deshabilitar excluye el control del cálculo de validez del form.
        control.disable({ emitEvent: false });
        console.log('[showDynamicFields] clearValidators + disable aplicado (RUT)', { fieldName: foundField.name, fieldId: foundField.id });
      }
    } else {
      if (visible) {
        control.enable({ emitEvent: false });
        control.setValidators(foundField.required ? [Validators.required] : []);
      } else {
        control.clearValidators();
        // FormArray/FormGroup: deshabilitar para que no cuente en form.valid (los hijos siguen con validadores)
        control.disable({ emitEvent: false });
        console.log('[showDynamicFields] clearValidators + disable aplicado', { fieldName: foundField.name, fieldId: foundField.id });
      }
    }

    control.updateValueAndValidity();
    const element: any = document.querySelector(`article[id="article-${foundField.id}"]`);
    if (element && element.style) {
      element.style.display = visible ? 'block' : 'none';
    }
  }

  /**
   * Process dynamic fields
   * @param fields
   * @param selectedOption
   */
  processDynamicFields(field, selectedOption) {

    if (field.type == 6 && field.values) {
      const sourceFields = (this.fields && this.fields.length > 0) ? this.fields : this.filterFields;

      if (typeof field.values === 'string') {
        try {
          field.values = JSON.parse(field.values);
        } catch (error) {
          console.error('[type6] No se pudo parsear values para campo:', field?.name, field?.values);
          return;
        }
      }

      const foundOption = field.values.find((x) => x.name == selectedOption);
      if (!foundOption) {
        console.warn('[type6] No se encontró opción seleccionada en values', {
          fieldName: field?.name,
          selectedOption,
          availableOptions: Array.isArray(field.values) ? field.values.map((x: any) => x?.name) : field.values
        });
        return;
      }

      // Inicializar el array de campos dinámicos para este campo tipo 6 si no existe
      if (!this.dynamicFields[field.id]) {
        this.dynamicFields[field.id] = [];
      }

      if (foundOption && foundOption.hasOwnProperty('values') && foundOption.values.length > 0) {
        // Ocultar solo los campos dinámicos de este campo tipo 6 específico
        for (const fieldName of this.dynamicFields[field.id]) {
          const resolved = this.type6DynamicFieldName(fieldName) || fieldName;
          const foundField = this.findField(sourceFields, resolved);
          if (foundField) {
            this.showDynamicFields(foundField, false)
          }
        }
        const dynamicNames = this.type6OptionDynamicNames(foundOption.values);
        this.dynamicFields[field.id] = dynamicNames;

        for (const fieldName of dynamicNames) {
          const foundField = this.findField(sourceFields, fieldName);
          if (foundField) {
            this.showDynamicFields(foundField, true)
          } else {
            const candidates = (sourceFields || [])
              .map((f: any) => f?.name)
              .filter((n: any) => n != null);
            console.warn('[type6] Campo dinámico no encontrado por nombre', {
              triggerField: field?.name,
              option: selectedOption,
              missingFieldName: fieldName,
              availableFieldNamesSample: candidates.slice(0, 25),
              totalAvailableFieldNames: candidates.length
            });
          }
        }
        this.applyType6ReplaceAlias(foundOption, sourceFields);
      } else if (foundOption && (!foundOption.hasOwnProperty('values') || foundOption.values.length == 0)) {
        // Ocultar solo los campos dinámicos de este campo tipo 6 específico
        for (const fieldName of this.dynamicFields[field.id]) {
          const resolved = this.type6DynamicFieldName(fieldName) || fieldName;
          const foundField = this.findField(sourceFields, resolved);
          if (foundField) {
            this.showDynamicFields(foundField, false)
          }
        }
        this.dynamicFields[field.id] = [];
      }
    }
  }

  private parseJsonIfString(raw: any): any {
    if (raw == null) return null;
    if (typeof raw !== 'string') return raw;
    try {
      let s = raw.trim();
      if ((s.startsWith("'") && s.endsWith("'")) || (s.startsWith('"') && s.endsWith('"'))) {
        s = s.slice(1, -1).replace(/\\'/g, "'").replace(/\\"/g, '"');
      }
      return JSON.parse(s);
    } catch {
      return null;
    }
  }

  /** Busca customfield tipo 53 desde fielddependencies u objeto de opción (type53FieldId / type53FieldName). */
  private resolveType53FieldFromDepsOrOption(depsOrOpt: any): any {
    if (!depsOrOpt || typeof depsOrOpt !== 'object') return null;
    const sourceFields = (this.fields && this.fields.length > 0) ? this.fields : this.filterFields;
    const allFieldsFromGroups = (this.customfieldsAlls && Array.isArray(this.customfieldsAlls))
      ? this.customfieldsAlls
        .flatMap((g: any) => Array.isArray(g?.fields) ? g.fields : [])
      : [];
    const unifiedSource = [...(sourceFields || []), ...allFieldsFromGroups];
    const id = depsOrOpt.type53FieldId ?? depsOrOpt.syncType53FieldId;
    const name = depsOrOpt.type53FieldName ?? depsOrOpt.syncType53FieldName;
    if (id != null && id !== '') {
      const byId = unifiedSource.find((f: any) => f && f.id == id && f.type === 53);
      if (byId) return byId;
    }
    if (name) {
      // 1) exacto por name
      let byName = unifiedSource.find((f: any) => f && f.type === 53 && f.name === name);
      if (byName) return byName;

      // 2) exacto por alias
      byName = unifiedSource.find((f: any) => f && f.type === 53 && f.alias === name);
      if (byName) return byName;

      // 3) tolerante (acentos/mayúsculas/espacios) por name o alias
      const target = this.normalizeFieldName(name);
      byName = unifiedSource.find((f: any) => {
        if (!f || f.type !== 53) return false;
        return this.normalizeFieldName(f.name) === target || this.normalizeFieldName(f.alias) === target;
      });
      if (byName) return byName;
    }
    return null;
  }

  private getMergedFielddependenciesForField(field: any): any {
    let deps = field.fielddependencies;
    deps = deps && typeof deps === 'string' ? this.parseJsonIfString(deps) : deps;
    if (deps) return deps;

    let originalField = this.fields?.find((f: any) => f.id === field.id);
    if (!originalField && this.filterFields) {
      originalField = this.filterFields.find((f: any) => f.id === field.id);
    }
    if (!originalField && this.customfieldsAlls) {
      for (const group of this.customfieldsAlls) {
        if (group.fields && Array.isArray(group.fields)) {
          originalField = group.fields.find((f: any) => f.id === field.id);
          if (originalField) break;
        }
      }
    }
    if (!originalField?.fielddependencies) return null;
    const parsed = this.parseJsonIfString(originalField.fielddependencies);
    return parsed != null ? parsed : originalField.fielddependencies;
  }

  /** Invocado por el padre para aplicar sync en esta instancia si aquí existe el tipo 53. */
  tryApplyTipoEmpresaOnType53Field(field53: any, tipoEmpresaId: string | number): boolean {
    return this.applyTipoEmpresaSelectionToType53(field53, tipoEmpresaId);
  }

  private getType53RootFormGroup(field53: any): FormGroup | null {
    if (!this.formCustomFields?.controls || !field53 || field53.id == null) return null;
    const id = field53.id;
    const raw =
      this.formCustomFields.controls[id] ?? this.formCustomFields.controls[String(id)];
    return raw instanceof FormGroup ? raw : null;
  }

  /**
   * Sincroniza `tipoEmpresa` y `documentos` del tipo 53.
   * BD: opciones type 6 con tipoEmpresaId; fielddependencies con type53FieldId / type53FieldName.
   */
  private applyTipoEmpresaSelectionToType53(field53: any, tipoEmpresaId: string | number): boolean {
    const control = this.getType53RootFormGroup(field53);
    if (!control) return false;

    let values = field53.values;
    if (typeof values === 'string' && values.includes('[')) {
      try {
        values = JSON.parse(values);
        field53.values = values;
      } catch {
        return false;
      }
    }
    if (!values || !Array.isArray(values)) return false;

    const tipoEmpresaIdStr =
      tipoEmpresaId !== undefined && tipoEmpresaId !== null && tipoEmpresaId !== ''
        ? String(tipoEmpresaId)
        : '';

    let nuevosDocumentos = [];
    if (tipoEmpresaIdStr) {
      const tipoEmpresa = values.find((emp: any) =>
        String(emp.id) === tipoEmpresaIdStr || emp.id == tipoEmpresaId
      );
      if (tipoEmpresa?.files && Array.isArray(tipoEmpresa.files)) {
        nuevosDocumentos = tipoEmpresa.files.map((file: any) =>
          this.fb.group({
            fileId: [file.id],
            fileName: [file.name],
            file: [null, type53FileValidators(field53, file)]
          })
        );
      }
    }

    let normalizedTipo: number | string | null = null;
    if (tipoEmpresaIdStr) {
      if (typeof tipoEmpresaId === 'number') {
        normalizedTipo = tipoEmpresaId;
      } else {
        const n = Number(tipoEmpresaId);
        normalizedTipo = Number.isNaN(n) ? tipoEmpresaId : n;
      }
    }

    control.get('tipoEmpresa')?.setValue(normalizedTipo, { emitEvent: false });
    control.setControl('documentos', this.fb.array(nuevosDocumentos));
    control.updateValueAndValidity({ emitEvent: false });

    if (this.cdr) {
      this.cdr.detectChanges();
    }
    return true;
  }

  private syncType53FromType6Selection(type6Field: any, selectedOptionName: string): void {
    if (!type6Field || type6Field.type !== 6 || selectedOptionName == null || selectedOptionName === '') {
      return;
    }

    let values = type6Field.values;
    if (typeof values === 'string') {
      try {
        values = JSON.parse(values);
      } catch {
        return;
      }
    }
    if (!Array.isArray(values)) return;

    const opt = values.find((x: any) => x?.name === selectedOptionName);
    if (!opt) return;

    const empresaRaw = opt.tipoEmpresaId ?? opt.syncTipoEmpresaId ?? opt.empresaId;
    if (empresaRaw === undefined || empresaRaw === null || empresaRaw === '') {
      return;
    }

    const deps = this.getMergedFielddependenciesForField(type6Field);
    let field53 = this.resolveType53FieldFromDepsOrOption(deps);
    if (!field53) {
      field53 = this.resolveType53FieldFromDepsOrOption(opt);
    }
    if (!field53) {
      const type53Candidates = ((this.fields && this.fields.length > 0) ? this.fields : this.filterFields)
        .filter((f: any) => f && f.type === 53)
        .map((f: any) => ({ id: f.id, name: f.name, alias: f.alias }));
      console.warn('[type6->53] No se encontró campo tipo 53 para sincronizar', {
        type6Field: { id: type6Field?.id, name: type6Field?.name },
        selectedOptionName,
        deps,
        optionConfig: opt,
        type53Candidates
      });
      return;
    }

    this.applyTipoEmpresaSelectionToType53(field53, empresaRaw);
    this.tipoEmpresaSyncToType53AcrossTabs.emit({
      field53,
      tipoEmpresaId: empresaRaw,
    });
  }

  private resolveType53FieldInType48(type48FieldId: number, depsOrOpt: any): any {
    if (!depsOrOpt || typeof depsOrOpt !== 'object') return null;
    const type48Field = this.fields.find((f: any) => f.id === type48FieldId && f.type === 48);
    if (!type48Field?.customfields || !Array.isArray(type48Field.customfields)) return null;
    const source = type48Field.customfields;

    const id = depsOrOpt.type53FieldId ?? depsOrOpt.syncType53FieldId;
    const name = depsOrOpt.type53FieldName ?? depsOrOpt.syncType53FieldName;
    if (id != null && id !== '') {
      const byId = source.find((f: any) => f && f.type === 53 && f.id == id);
      if (byId) return byId;
    }
    if (name) {
      let byName = source.find((f: any) => f && f.type === 53 && (f.name === name || f.alias === name));
      if (byName) return byName;
      const target = this.normalizeFieldName(name);
      byName = source.find((f: any) =>
        f && f.type === 53 &&
        (this.normalizeFieldName(f.name) === target || this.normalizeFieldName(f.alias) === target)
      );
      if (byName) return byName;
    }
    return null;
  }

  private applyTipoEmpresaSelectionToType53InType48(type48FieldId: number, rowIndex: number, field53: any, tipoEmpresaId: string | number): void {
    const type48FormArray = this.formCustomFields.controls[type48FieldId] as FormArray;
    if (!type48FormArray || !type48FormArray.controls[rowIndex]) return;
    const rowFormGroup = type48FormArray.controls[rowIndex] as FormGroup;
    const fid = field53.id;
    const control = (rowFormGroup.controls[fid] ??
      rowFormGroup.controls[String(fid)]) as FormGroup;
    if (!(control instanceof FormGroup)) return;

    let values = field53.values;
    if (typeof values === 'string' && values.includes('[')) {
      try {
        values = JSON.parse(values);
        field53.values = values;
      } catch {
        return;
      }
    }
    if (!Array.isArray(values)) return;

    const idStr = tipoEmpresaId !== undefined && tipoEmpresaId !== null && tipoEmpresaId !== '' ? String(tipoEmpresaId) : '';
    let nuevosDocumentos = [];
    if (idStr) {
      const tipoEmpresa = values.find((emp: any) => String(emp.id) === idStr || emp.id == tipoEmpresaId);
      if (tipoEmpresa?.files && Array.isArray(tipoEmpresa.files)) {
        nuevosDocumentos = tipoEmpresa.files.map((file: any) =>
          this.fb.group({
            fileId: [file.id],
            fileName: [file.name],
            file: [null, type53FileValidators(field53, file)]
          })
        );
      }
    }
    const n = Number(tipoEmpresaId);
    const normalizedTipo = idStr ? (Number.isNaN(n) ? tipoEmpresaId : n) : null;
    control.get('tipoEmpresa')?.setValue(normalizedTipo, { emitEvent: false });
    control.setControl('documentos', this.fb.array(nuevosDocumentos));
    control.updateValueAndValidity({ emitEvent: false });
    if (this.cdr) this.cdr.detectChanges();
  }

  private syncType53FromType6SelectionInType48(type6Field: any, selectedOptionName: string, type48FieldId: number, rowIndex: number): void {
    if (!type6Field || type6Field.type !== 6 || selectedOptionName == null || selectedOptionName === '') return;
    let values = type6Field.values;
    if (typeof values === 'string') {
      try { values = JSON.parse(values); } catch { return; }
    }
    if (!Array.isArray(values)) return;
    const opt = values.find((x: any) => x?.name === selectedOptionName);
    if (!opt) return;
    const empresaRaw = opt.tipoEmpresaId ?? opt.syncTipoEmpresaId ?? opt.empresaId;
    if (empresaRaw === undefined || empresaRaw === null || empresaRaw === '') return;

    const deps = this.getMergedFielddependenciesForField(type6Field);
    let field53 = this.resolveType53FieldInType48(type48FieldId, deps);
    if (!field53) field53 = this.resolveType53FieldInType48(type48FieldId, opt);
    if (!field53) {
      // Fallback: permitir sincronizar un type53 ubicado fuera del subgrupo tipo 48
      let globalType53 = this.resolveType53FieldFromDepsOrOption(deps);
      if (!globalType53) {
        globalType53 = this.resolveType53FieldFromDepsOrOption(opt);
      }
      if (globalType53) {
        this.applyTipoEmpresaSelectionToType53(globalType53, empresaRaw);
        this.tipoEmpresaSyncToType53AcrossTabs.emit({
          field53: globalType53,
          tipoEmpresaId: empresaRaw,
        });
        return;
      }

      const type48Field = this.fields.find((f: any) => f.id === type48FieldId && f.type === 48);
      const type53Candidates = (type48Field?.customfields || [])
        .filter((f: any) => f && f.type === 53)
        .map((f: any) => ({ id: f.id, name: f.name, alias: f.alias }));
      console.warn('[type6->53|type48] No se encontró campo tipo 53 para sincronizar', {
        type6Field: { id: type6Field?.id, name: type6Field?.name },
        selectedOptionName, deps, optionConfig: opt, type53Candidates, type48FieldId, rowIndex
      });
      return;
    }

    this.applyTipoEmpresaSelectionToType53InType48(type48FieldId, rowIndex, field53, empresaRaw);
  }

  /**
   * Inicializar campos dinámicos para una fila específica de tipo 48
   * @param type48FieldId ID del campo tipo 48
   * @param rowIndex Índice de la fila
   */
  initializeDynamicFieldsInType48Row(type48FieldId: number, rowIndex: number) {
    const type48Field = this.fields.find((f: any) => f.id === type48FieldId && f.type === 48);
    if (!type48Field || !type48Field.customfields || !Array.isArray(type48Field.customfields)) {
      return;
    }

    // Inicializar la estructura si no existe
    if (!this.dynamicFieldsType48[type48FieldId]) {
      this.dynamicFieldsType48[type48FieldId] = {};
    }
    if (!this.dynamicFieldsType48[type48FieldId][rowIndex]) {
      this.dynamicFieldsType48[type48FieldId][rowIndex] = {};
    }

    // Obtener el FormArray del tipo 48
    const type48FormArray = this.formCustomFields.controls[type48FieldId] as FormArray;
    if (!type48FormArray || !type48FormArray.controls[rowIndex]) {
      return;
    }

    // Buscar campos tipo 6 dentro del tipo 48
    const type6Fields = type48Field.customfields.filter((field: any) => field.type == 6);

    // Inicializar registros para todos los campos tipo 6
    for (const type6Field of type6Fields) {
      if (type6Field && type6Field.hasOwnProperty('values') && Array.isArray(type6Field.values)) {
        if (!this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id]) {
          this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = [];
        }
      }
    }

    // Obtener el FormGroup de la fila
    const rowFormGroup = type48FormArray.controls[rowIndex] as FormGroup;

    // Para cada campo tipo 6, inicializar su registro basándose en el valor actual
    for (const type6Field of type6Fields) {
      if (type6Field && type6Field.hasOwnProperty('values') && Array.isArray(type6Field.values)) {
        const type6Value = rowFormGroup.controls[type6Field.id]?.value;

        if (type6Value && type6Value !== '' && type6Value !== null) {
          // Buscar la opción seleccionada
          const selectedOption = type6Field.values.find((opt: any) => opt.name === type6Value);

          if (selectedOption && selectedOption.hasOwnProperty('values') && Array.isArray(selectedOption.values) && selectedOption.values.length > 0) {
            // Actualizar el registro con los campos dinámicos de esta opción
            this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] =
              this.type6OptionDynamicNames(selectedOption.values);
          } else {
            this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = [];
          }
        } else {
          this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = [];
        }
      }
    }

    this.reevaluateAllDynamicFieldsInRow(type48FieldId, rowIndex);
  }

  /**
   * Evalúa las reglas de combinación de una opción contra los valores actuales de otros campos tipo 6
   * @param option Opción seleccionada con sus combinationRules
   * @param allType6Fields Todos los campos tipo 6 de la fila
   * @param rowFormGroup FormGroup de la fila con los valores actuales
   * @param type48Field Campo tipo 48 completo
   * @returns true si debe mostrarse, false si debe ocultarse
   */
  evaluateCombinationRules(option: any, allType6Fields: any[], rowFormGroup: FormGroup, type48Field: any): boolean {
    // Si no tiene reglas de combinación, se considera que debe mostrarse (comportamiento por defecto)
    if (!option || !option.hasOwnProperty('combinationRules') || !option.combinationRules) {
      return true;
    }

    const rules = option.combinationRules;

    // Si tiene showIf, todas las condiciones deben cumplirse
    if (rules.hasOwnProperty('showIf') && Array.isArray(rules.showIf)) {
      for (const condition of rules.showIf) {
        if (condition.hasOwnProperty('fieldName')) {
          // Buscar el campo tipo 6 por nombre
          const dependentField = allType6Fields.find((f: any) => f.name === condition.fieldName);
          if (!dependentField) {
            // Si no se encuentra el campo dependiente, no mostrar
            return false;
          }

          // Obtener el valor actual del campo dependiente
          const dependentValue = rowFormGroup.controls[dependentField.id]?.value;

          // Si el campo dependiente no tiene valor, no mostrar
          if (!dependentValue || dependentValue === '' || dependentValue === null) {
            return false;
          }

          // Evaluar condición equals
          if (condition.hasOwnProperty('equals') && Array.isArray(condition.equals)) {
            if (!condition.equals.includes(dependentValue)) {
              return false;
            }
          }

          // Evaluar condición notEquals
          if (condition.hasOwnProperty('notEquals') && Array.isArray(condition.notEquals)) {
            if (condition.notEquals.includes(dependentValue)) {
              return false;
            }
          }
        }
      }
    }

    // Si todas las condiciones se cumplen, mostrar
    return true;
  }

  /**
   * Re-evalúa todos los campos dinámicos en una fila basándose en todos los campos tipo 6 y sus reglas de combinación
   * @param type48FieldId ID del campo tipo 48
   * @param rowIndex Índice de la fila
   */
  reevaluateAllDynamicFieldsInRow(type48FieldId: number, rowIndex: number) {
    const type48Field = this.fields.find((f: any) => f.id === type48FieldId && f.type === 48);
    if (!type48Field || !type48Field.customfields) {
      return;
    }

    // Obtener el FormArray del tipo 48
    const type48FormArray = this.formCustomFields.controls[type48FieldId] as FormArray;
    if (!type48FormArray || !type48FormArray.controls[rowIndex]) {
      return;
    }

    const rowFormGroup = type48FormArray.controls[rowIndex] as FormGroup;

    // Obtener todos los campos tipo 6 de la fila
    const allType6Fields = type48Field.customfields.filter((field: any) => field.type == 6);

    // Recopilar todos los campos dinámicos posibles y qué campos tipo 6 los mencionan
    const dynamicFieldsMap: { [fieldName: string]: { shouldShow: boolean, fields: any[] } } = {};

    // Primero, actualizar los registros de cada campo tipo 6 con sus valores actuales
    for (const type6Field of allType6Fields) {
      if (!type6Field || !type6Field.hasOwnProperty('values') || !Array.isArray(type6Field.values)) {
        continue;
      }

      // Inicializar la estructura si no existe
      if (!this.dynamicFieldsType48[type48FieldId]) {
        this.dynamicFieldsType48[type48FieldId] = {};
      }
      if (!this.dynamicFieldsType48[type48FieldId][rowIndex]) {
        this.dynamicFieldsType48[type48FieldId][rowIndex] = {};
      }
      if (!this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id]) {
        this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = [];
      }

      if (!this.type6IsActiveInRow(type6Field, allType6Fields, rowFormGroup)) {
        this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = [];
        continue;
      }

      // Obtener el valor actual del campo tipo 6
      const type6Value = rowFormGroup.controls[type6Field.id]?.value;

      // Buscar la opción seleccionada
      const selectedOption = type6Field.values.find((opt: any) => opt.name === type6Value);

      if (selectedOption && selectedOption.hasOwnProperty('values') && Array.isArray(selectedOption.values) && selectedOption.values.length > 0) {
        // Actualizar el registro de este campo tipo 6
        const dynamicNames = this.type6OptionDynamicNames(selectedOption.values);
        this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = dynamicNames;

        const shouldShow = this.evaluateCombinationRules(selectedOption, allType6Fields, rowFormGroup, type48Field);

        for (const dynamicFieldName of dynamicNames) {
          if (!dynamicFieldsMap[dynamicFieldName]) {
            dynamicFieldsMap[dynamicFieldName] = { shouldShow: false, fields: [] };
          }
          dynamicFieldsMap[dynamicFieldName].fields.push({ type6Field, selectedOption, shouldShow });

          // Si este campo tipo 6 indica que debe mostrarse (con o sin reglas), marcar como shouldShow
          if (shouldShow) {
            dynamicFieldsMap[dynamicFieldName].shouldShow = true;
          }
        }
      } else {
        // Si no hay opción seleccionada o no tiene values, limpiar el registro
        this.dynamicFieldsType48[type48FieldId][rowIndex][type6Field.id] = [];
      }
    }

    // Aplicar la visibilidad final a cada campo dinámico
    // Primero, preservar valores antes de mostrar/ocultar
    for (const dynamicFieldName in dynamicFieldsMap) {
      const foundField = this.findField(type48Field.customfields, dynamicFieldName);
      if (foundField) {
        // Preservar el valor del campo si existe en el FormGroup (para modo edición o cuando se re-evalúa)
        const fieldValue = rowFormGroup.controls[foundField.id]?.value;
        if (fieldValue !== null && fieldValue !== undefined) {
          // Normalizar arrays: si es un array con un string vacío ["], mantenerlo como string vacío
          // Si es un array con un valor, tomar el primer elemento
          if (Array.isArray(fieldValue)) {
            if (fieldValue.length === 0) {
              foundField.value = '';
            } else if (fieldValue.length === 1) {
              foundField.value = fieldValue[0] === '' ? '' : fieldValue[0];
            } else {
              foundField.value = fieldValue[0];
            }
          } else if (fieldValue !== '') {
            // Si no es array y no es string vacío, usar el valor directamente
            foundField.value = fieldValue;
          } else {
            // Si es string vacío, mantenerlo como string vacío
            foundField.value = '';
          }
        }
      }
    }

    // Aplicar la visibilidad final a cada campo dinámico
    for (const dynamicFieldName in dynamicFieldsMap) {
      const foundField = this.findField(type48Field.customfields, dynamicFieldName);
      if (foundField) {
        const shouldShow = dynamicFieldsMap[dynamicFieldName].shouldShow;
        this.showDynamicFieldsInType48(foundField, shouldShow, type48FieldId, rowIndex);
      }
    }

    // También ocultar campos dinámicos que no están en ningún registro activo
    // (para manejar el caso cuando se cambia de una opción con values a una sin values)
    const allDynamicFieldsInRecords = new Set<string>();
    for (const type6Field of allType6Fields) {
      const registeredFields = this.dynamicFieldsType48[type48FieldId]?.[rowIndex]?.[type6Field.id] || [];
      registeredFields.forEach((fieldName: string) => allDynamicFieldsInRecords.add(fieldName));
    }

    // Obtener todos los campos dinámicos posibles de todas las opciones
    const allPossibleDynamicFields = new Set<string>();
    for (const type6Field of allType6Fields) {
      if (type6Field.values && Array.isArray(type6Field.values)) {
        for (const option of type6Field.values) {
          if (option.values && Array.isArray(option.values)) {
            this.type6OptionDynamicNames(option.values).forEach((fieldName) =>
              allPossibleDynamicFields.add(fieldName)
            );
          }
        }
      }
    }

    // Ocultar campos dinámicos que no están en ningún registro activo
    for (const dynamicFieldName of allPossibleDynamicFields) {
      if (!allDynamicFieldsInRecords.has(dynamicFieldName)) {
        const foundField = this.findField(type48Field.customfields, dynamicFieldName);
        if (foundField) {
          this.showDynamicFieldsInType48(foundField, false, type48FieldId, rowIndex);
        }
      }
    }
    this.syncCopyLocksForRow(type48FieldId, rowIndex);
  }

  /**
   * Process dynamic fields dentro de tipo 48
   * @param field Campo tipo 6 que cambió
   * @param selectedOption Opción seleccionada
   * @param type48FieldId ID del campo tipo 48
   * @param rowIndex Índice de la fila dentro del FormArray
   */
  processDynamicFieldsInType48(field: any, selectedOption: string, type48FieldId: number, rowIndex: number) {
    if (field.type == 6 && field.values) {
      if (typeof field.values === 'string') {
        try {
          field.values = JSON.parse(field.values);
        } catch {
          console.error('[type6/48] No se pudo parsear values:', field?.name);
          return;
        }
      }
      if (!Array.isArray(field.values)) {
        return;
      }
      const foundOption = field.values.find((x) => x.name == selectedOption);

      // Inicializar la estructura si no existe
      if (!this.dynamicFieldsType48[type48FieldId]) {
        this.dynamicFieldsType48[type48FieldId] = {};
      }
      if (!this.dynamicFieldsType48[type48FieldId][rowIndex]) {
        this.dynamicFieldsType48[type48FieldId][rowIndex] = {};
      }
      if (!this.dynamicFieldsType48[type48FieldId][rowIndex][field.id]) {
        this.dynamicFieldsType48[type48FieldId][rowIndex][field.id] = [];
      }

      // Buscar el campo tipo 48 para obtener sus customfields
      const type48Field = this.fields.find((f: any) => f.id === type48FieldId && f.type === 48);
      if (!type48Field || !type48Field.customfields) {
        return;
      }

      // Actualizar el registro del campo que cambió
      if (foundOption && foundOption.hasOwnProperty('values') && foundOption.values.length > 0) {
        // Actualizar el registro de este campo tipo 6
        this.dynamicFieldsType48[type48FieldId][rowIndex][field.id] =
          this.type6OptionDynamicNames(foundOption.values);
      } else if (foundOption && (!foundOption.hasOwnProperty('values') || foundOption.values.length == 0)) {
        // Limpiar el registro de este campo tipo 6
        this.dynamicFieldsType48[type48FieldId][rowIndex][field.id] = [];
      }

      // Re-evaluar todos los campos dinámicos en la fila basándose en todos los campos tipo 6
      this.reevaluateAllDynamicFieldsInRow(type48FieldId, rowIndex);
    }
  }

  /**
   * Show or hide dynamic fields dentro de tipo 48
   * @param foundField Campo a mostrar/ocultar
   * @param visible true para mostrar, false para ocultar
   * @param type48FieldId ID del campo tipo 48
   * @param rowIndex Índice de la fila dentro del FormArray
   */
  showDynamicFieldsInType48(foundField: any, visible: boolean, type48FieldId: number, rowIndex: number) {
    // Obtener el FormArray del tipo 48
    const type48FormArray = this.formCustomFields.controls[type48FieldId] as FormArray;
    if (!type48FormArray || !type48FormArray.controls[rowIndex]) {
      return;
    }
    // Obtener el FormGroup de la fila específica
    const rowFormGroup = type48FormArray.controls[rowIndex] as FormGroup;

    // Mismo comportamiento que showDynamicFields
    let valueField = '';
    if (visible) {
      // Primero verificar si ya existe un valor en el FormGroup (datos guardados o preservados)
      const existingValue = rowFormGroup.controls[foundField.id]?.value;

      // Normalizar el valor: convertir arrays a valores simples
      if (existingValue !== null && existingValue !== undefined) {
        if (Array.isArray(existingValue)) {
          if (existingValue.length === 0) {
            valueField = '';
          } else if (existingValue.length === 1) {
            // Si es un array con un elemento, tomar ese elemento
            // Si el elemento es string vacío, mantenerlo como string vacío
            valueField = existingValue[0] === '' ? '' : existingValue[0];
          } else {
            // Si tiene múltiples elementos, tomar el primero (caso especial)
            valueField = existingValue[0];
          }
        } else if (existingValue !== '') {
          // Si no es array y no es string vacío, usar el valor directamente
          valueField = existingValue;
        }
        // Si existingValue es string vacío '', mantener valueField como ''
      } else if (foundField.value !== null && foundField.value !== undefined) {
        // Si no hay valor en FormGroup pero hay en foundField, usarlo
        if (Array.isArray(foundField.value)) {
          if (foundField.value.length === 0) {
            valueField = '';
          } else if (foundField.value.length === 1) {
            valueField = foundField.value[0] === '' ? '' : foundField.value[0];
          } else {
            valueField = foundField.value[0];
          }
        } else if (foundField.value !== '') {
          valueField = foundField.value;
        }
        // Si foundField.value es string vacío '', mantener valueField como ''
      }
    }

    // Actualizar el valor del campo en el FormGroup de la fila (igual que showDynamicFields pero en el FormGroup de la fila)
    if (rowFormGroup.controls[foundField.id]) {
      // Asegurarse de que valueField nunca sea un array
      let finalValue = valueField;
      if (Array.isArray(finalValue)) {
        if (finalValue.length === 0) {
          finalValue = '';
        } else {
          finalValue = finalValue[0] === '' ? '' : finalValue[0];
        }
      }

      // Si finalValue está vacío pero hay un valor actual en el FormControl, preservarlo
      // Esto evita que se pierdan valores cuando se re-evalúan los campos dinámicos
      if ((!finalValue || finalValue === '') && visible) {
        const currentValue = rowFormGroup.controls[foundField.id].value;
        if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
          // Normalizar el valor actual si es un array
          if (Array.isArray(currentValue)) {
            if (currentValue.length > 0 && currentValue[0] !== '') {
              finalValue = currentValue[0];
            }
          } else {
            finalValue = currentValue;
          }
        }
      }

      const rowControl = rowFormGroup.controls[foundField.id];
      // Solo setValue en FormControl: FormArray/FormGroup requieren array/objeto y provocan NG01002
      if (rowControl instanceof FormControl) {
        if (visible) {
          // Aplicar defaultvalue solo en la PRIMERA materializacion del campo.
          // No basta con rowControl.pristine: el form (formCustomFields) se reconstruye
          // entero al navegar entre pasos del wizard (ngOnChanges -> ngOnInit), y los
          // FormControl renacen pristine aunque el usuario ya haya interactuado. Por eso
          // ademas nos apoyamos en senales que SI sobreviven al rebuild:
          //   - this.edit: en edicion, foundField.value/'' es la verdad del backend.
          //   - _preservedRow: ESTA fila (no el field48 compartido) se reconstruyo desde un
          //     snapshot de navegacion, asi que un vacio es intencional. Se marca por fila en
          //     addRepeat para no afectar filas nuevas agregadas despues por el usuario.
          const rowWasPreserved = !!(rowFormGroup as any)._preservedRow;
          if (shouldApplyDefaultValue({
            finalValue,
            defaultValue: foundField.defaultvalue,
            // edit y flagActionLog son equivalentes en este componente: ambos indican
            // que los datos vienen del backend (ver linea 1278: editRepeat vs addRepeat).
            isEdit: !!(this.edit || this.flagActionLog),
            rowWasPreserved,
            controlPristine: rowControl.pristine,
          })) {
            finalValue = foundField.defaultvalue;
          }
          rowControl.setValue(finalValue, { emitEvent: false });
        } else {
          rowControl.setValue('', { emitEvent: false });
        }
      }

      if (visible) {
        rowControl.enable({ emitEvent: false });
        const validators = [];
        if (foundField.type == 8) {
          validators.push(correctRutValidator());
        } else {
          if (foundField.required) {
            validators.push(Validators.required);
          }
          if (foundField.regularexpression) {
            validators.push(Validators.pattern(foundField.regularexpression));
          }
        }
        rowControl.setValidators(validators);
      } else {
        rowControl.clearValidators();
        rowControl.setErrors(null);
        rowControl.disable({ emitEvent: false });
      }

      rowControl.updateValueAndValidity({ emitEvent: false });
    }

    // Por fila: no escribir foundField.hidden (ese objeto lo comparten todas las filas).
    this.type48RowHidden.set(
      this.type48RowHiddenKey(type48FieldId, rowIndex, foundField.id),
      !visible
    );

    // Mostrar/ocultar el elemento DOM usando el atributo data-field-id para identificar específicamente el campo
    const element: any = document.querySelector(`article[data-type48-id="${type48FieldId}"][data-row-index="${rowIndex}"][data-field-id="${foundField.id}"]`);
    if (element) {
      if (visible) {
        element.removeAttribute('hidden');
        if (element.style) element.style.display = '';
      } else if (element.style) {
        element.style.display = 'none';
      }
    } else {
      // Fallback: buscar por el article que contiene el formcontrolname dentro de app-custom-fields-switch
      const articles = document.querySelectorAll(`article[data-type48-id="${type48FieldId}"][data-row-index="${rowIndex}"]`);
      articles.forEach((article: any) => {
        // Buscar dentro del app-custom-fields-switch el formcontrolname
        const customFieldsSwitch = article.querySelector('app-custom-fields-switch');
        if (customFieldsSwitch) {
          const fieldControl = customFieldsSwitch.querySelector(`[formcontrolname="${foundField.id}"]`);
          if (fieldControl) {
            if (visible) {
              article.removeAttribute('hidden');
              if (article.style) article.style.display = '';
            } else if (article.style) {
              article.style.display = 'none';
            }
          }
        }
      });
    }
    if (this.cdr) {
      this.cdr.detectChanges();
    }
  }

  async onChange(event?, type48FieldId?: number, rowIndex?: number) {
    console.log('🔵 onChange CALLED in customfields.component');
    console.log('🔵 Event received:', event);
    console.log('🔵 type48FieldId:', type48FieldId, 'rowIndex:', rowIndex);

    let e;
    let fields;
    try {
      // El evento puede venir en diferentes formatos
      if (event && typeof event === 'object') {
        if (event.e && event.fields) {
          // Formato: { e: {...}, fields: {...} }
          e = event.e;
          fields = event.fields;
        } else if (event.target && event.fields) {
          // Formato alternativo: { target: {...}, fields: {...} }
          e = event;
          fields = event.fields;
        } else if (event.fields) {
          // Solo tiene fields
          e = event.e || event;
          fields = event.fields;
        } else {
          // Intentar extraer directamente
          e = event.e || event.target || event;
          fields = event.fields;
        }
      } else {
        e = event;
        fields = undefined;
      }
      console.log('🔵 Extracted e:', e);
      console.log('🔵 Extracted fields:', fields);
      if (fields) {
        console.log('🔵 Field type:', fields.type, 'Field name:', fields.name);
        console.log('🔵 Field has fielddependencies?', !!fields.fielddependencies);
        console.log('🔵 Field fielddependencies value:', fields.fielddependencies);
        
        // Si fielddependencies es un string, parsearlo
        if (fields.fielddependencies && typeof fields.fielddependencies === 'string') {
          try {
            fields.fielddependencies = JSON.parse(fields.fielddependencies);
            console.log('🔵 Parsed fielddependencies from string:', fields.fielddependencies);
          } catch (parseError) {
            console.error('❌ Error parsing fielddependencies:', parseError);
            fields.fielddependencies = null;
          }
        }

        if (fields.fielddependencies) {
          console.log('🔵 Field dependencies (final):', fields.fielddependencies);
        }
      }
    } catch (error) {
      console.error('❌ Error extracting event:', error);
    }

    let setValueForm = { valid: false, value: {} };
    if (e && e.target && fields) {
      // Si type48FieldId y rowIndex están definidos, el campo está dentro de tipo 48
      if (type48FieldId !== undefined && rowIndex !== undefined) {
        this.processDynamicFieldsInType48(fields, e.target.value, type48FieldId, rowIndex);
        if (fields.type === 6) {
          this.syncType53FromType6SelectionInType48(fields, e.target.value, type48FieldId, rowIndex);
        }
      } else {
        // Campo fuera de tipo 48, comportamiento original
        this.processDynamicFields(fields, e.target.value);
        if (fields.type === 6) {
          // Opcional: opción type 6 con tipoEmpresaId + fielddependencies apuntando al type 53 (config en BD)
          this.syncType53FromType6Selection(fields, e.target.value);
        }
        if (fields.type === 52 && this.getCommonCounterpartyChildFields(fields).length) {
          void this.handleCommonCounterpartyParentChange(fields, e.target.value);
        }
      }
    }

    if (this.dateValueSet) {
      this.formCustomFields.value[this.dateValueSet.idCustomField] =
        this.dateValueSet.dateFormat;
    }
    if (this.terminarCausa && e && e.target && fields.type == 6) {
      const customfields2 = {};
      if (fields) {
        if (fields.name === 'Motivo') {
          this.seleccionados = [];
          this.arrkey = [];
        }
        if (!this.seleccionados.find((v) => v.name == fields.name)) {
          this.seleccionados.push(fields)
        }
        if (e && e.target) {
          this.arrkey.push({ id: fields.id, value: e.target.value })
        }
      }

      if (e && e.target) {
        let encontrado = fields.values.find((x) => x.name == e.target.value)
        if (encontrado) {
          this.filterFields = this.fields.filter((x) => {
            return encontrado.values.find((v) => x.name == v);
          });
          this.filterFields.unshift(...this.seleccionados)
          this.filterFields.map((item) => {
            if (item && !item.hasOwnProperty('value')) item['value'] = e.target.value
            let value = (item && item.value) ? item.value : "";
            if (item && item.id) {
              customfields2[item.id] = [value];
            }
          })
          this.formCustomFields = this.fb.group(customfields2);
          this.arrkey.map((item) => {
            this.formCustomFields.patchValue({
              [item.id]: item.value,
            });
          });

          if (fields.name === 'Motivo') {
            if (e.target.value === 'Sentencia') {
              let encontrado_fecha = this.filterFields.find((x) => x.name == 'Fecha de notificación de sentencia')
              this.seleccionados.push(encontrado_fecha)
            }
          }
        }
      }
    }

    if (fields) {
      if (type48FieldId !== undefined && rowIndex !== undefined) {
        this.handleCopyFromGroupChange(fields, e, type48FieldId, rowIndex);
      }
      this.syncAutoCopyFromGroups();

      if (fields.hasOwnProperty('format') && fields.format) {
        let lastItem = this.customfieldsAlls.find(x => x.name === fields.name);
        if (lastItem) {
          if (e !== "") {
            let res = e.replace('$', "").replace(/,00/g, "").replace(/[^/-\d,]/g, "").trim();
            this.formCustomFields.patchValue({
              [fields.id]:  this.parseNumber(res) ? e : res,
            });
            this.valueFieldsClon[fields.name] = res;

            await this.recalcular(fields.name);
          } else {
            this.valueFieldsClon[fields.name] = null;
            await this.recalcular(fields.name);
            this.formCustomFields.patchValue({
              [lastItem.id]: null,
            });
          }
        }
      }
      if (fields.type === 3) {
        const formattedDate = this.normalizeType3Value(e);
        if (formattedDate) {
          this.formCustomFields.patchValue({ [fields.id]: formattedDate }, { emitEvent: false });
        }
        setValueForm = this.cleanString(formattedDate, fields, true);
        if (fields.name === 'Fecha de notificación de sentencia') {
          this.seleccionados.forEach(element => {
            if (element.name == 'Fecha de notificación de sentencia') {
              element.value = formattedDate;
            }
          });
        }
      }
      console.log('formCustomFields 1', this.formCustomFields);
      if (fields.type === 9 || fields.type === 5 || fields.type === 37 || fields.type === 6 || fields.type === 4 || fields.type === 54 || (typeof e === 'object' && fields.type != 3)) {
        if (e && e.target) {
          setValueForm = this.cleanString(e.target.value, fields, true)

          // Si el campo es "País" (tipo 6), controlar Región y Comuna
          if (fields.type === 6 && fields.name === 'País' && this.formCustomFields) {
            this.syncChileLocationFields(e.target.value);
            if (this.cdr) {
              this.cdr.detectChanges();
            }
          }
        } else if ((fields.type === 4 || fields.type === 54) && e && typeof e === 'object' && e.target) {
          // Manejo específico para checkbox tipo 4 y toggle switch tipo 54
          setValueForm = this.cleanString(e.target.checked, fields, true);
        }
      }

      // Manejar dependencias de campos para tipo 54 (Toggle Switch)
      if (fields.type === 54) {
        // Parsear fielddependencies si viene como string o si es null, intentar obtenerlo del campo original
        if (fields.fielddependencies && typeof fields.fielddependencies === 'string') {
          try {
            // Limpiar el string si tiene comillas simples o dobles alrededor
            let cleanedString = fields.fielddependencies.trim();
            if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
              cleanedString = cleanedString.slice(1, -1);
              // Reemplazar comillas escapadas si es necesario
              cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
            }
            fields.fielddependencies = JSON.parse(cleanedString);
            console.log('🔵 Parsed fielddependencies from string in onChange:', fields.fielddependencies);
          } catch (parseError) {
            console.error('❌ Error parsing fielddependencies in onChange:', parseError, 'Raw value:', fields.fielddependencies);
            fields.fielddependencies = null;
          }
        }

        // Si aún es null, buscar el campo original en this.fields, this.filterFields o this.customfieldsAlls
        if (!fields.fielddependencies) {
          // Buscar en this.fields primero
          let originalField = this.fields?.find((f: any) => f.id === fields.id);

          // Si no se encuentra, buscar en this.filterFields
          if (!originalField && this.filterFields) {
            originalField = this.filterFields.find((f: any) => f.id === fields.id);
          }

          // Si no se encuentra, buscar en this.customfieldsAlls
          if (!originalField && this.customfieldsAlls) {
            for (const group of this.customfieldsAlls) {
              if (group.fields && Array.isArray(group.fields)) {
                originalField = group.fields.find((f: any) => f.id === fields.id);
                if (originalField) break;
              }
            }
          }

          if (originalField && originalField.fielddependencies) {
            if (typeof originalField.fielddependencies === 'string') {
              try {
                let cleanedString = originalField.fielddependencies.trim();
                if ((cleanedString.startsWith("'") && cleanedString.endsWith("'")) ||
                    (cleanedString.startsWith('"') && cleanedString.endsWith('"'))) {
                  cleanedString = cleanedString.slice(1, -1);
                  cleanedString = cleanedString.replace(/\\'/g, "'").replace(/\\"/g, '"');
                }
                fields.fielddependencies = JSON.parse(cleanedString);
                console.log('🔵 Found and parsed fielddependencies from original field in onChange:', fields.fielddependencies);
              } catch (parseError) {
                console.error('❌ Error parsing fielddependencies from original field in onChange:', parseError);
              }
            } else {
              fields.fielddependencies = originalField.fielddependencies;
              console.log('🔵 Found fielddependencies from original field in onChange:', fields.fielddependencies);
            }
          }
        }

        if (fields.fielddependencies) {
          const toggleValue = e && e.target ? e.target.checked : (typeof e === 'boolean' ? e : false);
          console.log('🔵 Toggle Switch changed - Field:', fields.name, 'Value:', toggleValue, 'Dependencies:', fields.fielddependencies);
          this.handleFieldDependencies(fields, toggleValue);
        } else {
          console.warn('⚠️ No fielddependencies found for field:', fields.name);
        }
      }
      if (fields.type === 20) {
        if (e && e.target) {
          this.subType20.changeOption(e.target.value, fields.values.subtype.data);
        }
      }
      if (fields.type === 22) {
        if (e && e.target) {
          this.type22.changeOption(e.target.value);
          this.getItem22Values({ event: e.target.value, name: 'type' });
        }
      }
      if (fields.type === 23) {
        if (e && e.target) {
          this.type22.changeOption(e.target.value);
        }
      }
      if (fields.type === 53) {
        // Para el tipo 53, siempre usar cleanString para mantener la estructura completa
        setValueForm = this.cleanString('', fields, true);
      }
      if (typeof e === 'string' || typeof e === 'number' && typeof e !== 'object') {
        setValueForm = this.cleanString(e, fields, true);
      }

    }
    this.setValueToConcatenatedField();
    // Asegurar que setValueForm tenga el estado de validación correcto del formulario
    if (!setValueForm.hasOwnProperty('valid') || setValueForm.valid === false) {
      setValueForm.valid = this.formCustomFields.valid;
    }
    if (!setValueForm.hasOwnProperty('value') || Object.keys(setValueForm.value || {}).length === 0) {
      setValueForm.value = this.formCustomFields.value;
    }
    if (!this.formCustomFields.valid) {
      const invalid = this.listInvalidCustomfields();
      if (invalid.length) {
        console.warn('[customfields] Campos que impiden continuar:', invalid);
      }
    }
    this.customfieldsValues.emit(setValueForm);
  }

  private listInvalidCustomfields(): string[] {
    const names = new Map<string, string>();
    const register = (field: any) => {
      if (!field || field.id == null) return;
      names.set(String(field.id), field.alias || field.name || String(field.id));
    };
    (this.fields || []).forEach((field: any) => {
      register(field);
      (field.customfields || []).forEach(register);
    });
    const invalid: string[] = [];
    const walk = (control: any, path: string) => {
      if (!control || control.disabled || control.valid) return;
      if (control.controls) {
        Object.keys(control.controls).forEach((key) => {
          const label = names.get(String(key)) || key;
          walk(control.controls[key], path ? `${path} → ${label}` : label);
        });
        return;
      }
      invalid.push(`${path} (${Object.keys(control.errors || {}).join(', ') || 'invalid'})`);
    };
    walk(this.formCustomFields, '');
    return invalid;
  }

  //Arma el value de campo rit tipo 45
  setValueToConcatenatedField() {
    const customField = this.fields.find((item) => item.name === 'RIT de origen' && !item.format && item.type == 45);
    if (customField && customField.values) {
      const arrayValues = [];
      customField.values.forEach((name: string) => {
        const field = this.fields.find((item) => item.name === name);
        if (field) {

          if (this.formCustomFields.controls[field.id].value) {
            arrayValues.push(this.formCustomFields.controls[field.id].value);
          }

        }
      });
      if (arrayValues && arrayValues.length == customField.values.length) {
        this.formCustomFields.controls[customField.id].setValue(arrayValues.join('-'));
      }
    }
  }

  /** Normaliza valor de customfield tipo fecha (NgbDateStruct, string DD/MM/YYYY o ISO). */
  normalizeType3Value(value: any): string {
    if (value == null || value === '') {
      return '';
    }
    if (typeof value === 'object' && value.year != null && value.month != null && value.day != null) {
      return this.dateformatService.format(value as NgbDateStruct);
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed || trimmed === 'null') {
        return '';
      }
      const parsed = this.dateformatService.parse(trimmed);
      return parsed ? this.dateformatService.format(parsed) : trimmed;
    }
    return String(value);
  }

  private normalizeType55Value(value: any): any {
    if (!Array.isArray(value) || value.length === 0) {
      return '';
    }

    const firstValue = value[0] || {};
    const hasMainSelection = firstValue.seleccion != null && firstValue.seleccion !== '';
    const hasSubSelection = Array.isArray(firstValue.sub) && firstValue.sub.some((item: any) =>
      item && Object.keys(item).some((key: string) => item[key] != null && item[key] !== '')
    );
    const hasSub2Selection = Array.isArray(firstValue.sub2) && firstValue.sub2.some((item: any) =>
      item && Object.keys(item).some((key: string) => item[key] != null && item[key] !== '')
    );

    return hasMainSelection || hasSubSelection || hasSub2Selection ? value : '';
  }

  /** Valores actuales del formulario listos para enviar al API (fechas en DD/MM/YYYY). */
  getValuesForSave(): Record<string, any> {
    if (!this.formCustomFields) {
      return {};
    }
    const values = { ...this.formCustomFields.getRawValue() };
    (this.fields || []).forEach((field: any) => {
      if (field.type === 3 && values[field.id] != null) {
        values[field.id] = this.normalizeType3Value(values[field.id]);
      }
      if (field.type === this.CUSTOMFIELD_NESTED_DUAL && values[field.id] != null) {
        values[field.id] = this.normalizeType55Value(values[field.id]);
      }
      if (field.type === 52 && values[field.id] != null && values[field.id] !== '') {
        values[field.id] = serializeType52ForStorage(values[field.id], field);
      }
      if (field.type === 2 && field.format && values[field.id] != null && values[field.id] !== '') {
        values[field.id] = normalizeMontoForStorage(values[field.id]);
      }
    });
    return values;
  }

  cleanString(e, field, flag) {
    console.log('formCustomFields 2', this.formCustomFields);
    let changeValue = { valid: this.formCustomFields.valid, value: { ...this.formCustomFields.getRawValue() } };
    if (flag) {
      if (field.type == 14 || field.type == 55) {
        // Verificar si el campo está dentro de una agrupación tipo 48
        let isInGrouping = false;
        const type48Fields = this.fields.filter((f: any) => f.type === 48);
        for (const type48Field of type48Fields) {
          if (type48Field.customfields && Array.isArray(type48Field.customfields)) {
            const foundInGroup = type48Field.customfields.find((cf: any) => cf.id === field.id);
            if (foundInGroup) {
              isInGrouping = true;
              break;
            }
          }
        }

        // Si está dentro de una agrupación, el valor ya está en el FormArray de la agrupación
        // y será procesado por extractData, no necesitamos hacer nada aquí
        if (!isInGrouping) {
          // Campo tipo 14 fuera de agrupación (comportamiento original)
          if (this.formCustomFields.value[field.id] && this.formCustomFields.value[field.id][0] && this.formCustomFields.value[field.id][0]["sub"]) {
            if (this.formCustomFields.value[field.id][0]["sub"].length == 0) {
              changeValue.value[field.id] = [{ seleccion: e, sub: [] }];
            }
            else {
              changeValue.value[field.id] = this.formCustomFields.value[field.id]
            }
          }
        }
        // Si está en agrupación, no hacer nada - el valor ya está en el FormArray correcto
      } else if (field.type == 53) {
        // Para el tipo 53, mantener la estructura completa del FormGroup
        const fieldGroup = this.formCustomFields.controls[field.id] as FormGroup;
        const tipoEmpresa = fieldGroup.get('tipoEmpresa')?.value;
        const documentosArray = fieldGroup.get('documentos') as FormArray;

        const documentosData = documentosArray.controls.map((control: FormGroup) => ({
          fileId: control.get('fileId')?.value,
          fileName: control.get('fileName')?.value,
          file: control.get('file')?.value
        }));

        changeValue.value[field.id] = {
          tipoEmpresa: tipoEmpresa,
          documentos: documentosData
        };
      } else if (field.type !== 13 && field.type !== 12) {
        changeValue.value[field.id] = e;
      }
    }

    for (const property in changeValue.value) {
      const fieldDef = this.fields?.find((f: any) => String(f.id) === String(property));
      if (fieldDef?.type === 3) {
        changeValue.value[property] = this.normalizeType3Value(changeValue.value[property]);
        continue;
      }

      if (field.type == 9 && this.formatRut(field.value) == this.formatRut(changeValue.value[property])) {
        changeValue.value[property] = this.formatRut(changeValue.value[property]);
      }

      if (field.type != 8 && field.type != 5) {
        let temp = this.replaceFormat(changeValue.value[property])
        changeValue.value[property] = this.parseNumber(temp) ? changeValue.value[property] : temp;
      } else {
        // Si el campo tiene skipFormatting o noFormat, no formatear
        if (field.skipFormatting || field.noFormat || field.type == 5) {
          changeValue.value[field.id] = this.formCustomFields.value[field.id];
        } else {
          changeValue.value[field.id] = this.formatRut(this.formCustomFields.value[field.id]);
        }
      }

    }

    const customfields = this.fields.filter((field)=> field.type == this.CUSTOMFIELD_NESTED || field.type == this.CUSTOMFIELD_NESTED_DUAL)
    if(customfields){
      customfields.forEach((field)=>{
        if(this.formCustomFields.value[field.id] && this.formCustomFields.value[field.id].length>0){
          if (this.formCustomFields.value[field.id][0]["sub"].length > 0) {
            if(this.formCustomFields.value[field.id][0]["sub"][0]['seleccion1'] == ''){
              this.formCustomFields.controls[field.id].setErrors({'incorrect': true})
            }
          }
        }
      });
    }


    return changeValue;
  }



  parseNumber(temp) {
    return isNaN(Number(temp === '' ? NaN : temp));
  }

  replaceFormat(value) {
    return typeof value === 'string' && value.includes('$') ? value.replace('$', "").replace('%', '').replace(/,00/g, '').replace(/[^/-\d,]/g, "").trim() : value;
  }

  formatter(str, isNum) {
    str = String(Number(str || 0) / (isNum ? 1 : 100));
    str = (str == '0' ? '0.0' : str).split('.');
    str[1] = str[1] || '0';
    let number = str[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ',' + (str[1].length == 1 ? str[1] + '0' : str[1]);
    return number;
  }

  decimalAdjust(type, value, exp) {
    // Si el exp no está definido o es cero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value + Number.EPSILON);
    }
    value = +value;
    exp = +exp;
    // Si el valor no es un número o el exp no es un entero...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  formatterValid(value, format) {
    let simbol = this.getSimbol(format);
    let valor = '';
    if (!format && format !== null) {
      // valor = this.formatter(this.decimalAdjust('round',value,-1),true).replace(/,00/g,'');
      let rounde = Math.round((Number(value) + Number.EPSILON) * 100) / 100;
      valor = String(this.formatter(rounde, true));
    } else {
      valor = this.formatter(value, true)
    }
    return simbol === '$' ? simbol + valor : valor + simbol;
  }

  getSimbol(formatCustom) {
    return formatCustom === null || formatCustom === undefined ? '' : formatCustom ? '$' : '%';
  }

  async recalcular(key?) {
    const promises = this.customfields45.map((x) => {
      this.valueFieldsClon[x.field.name] = x.field.formula;
      return this.calculateFormula({
        id: x.field.id,
        name: x.field.name,
        values: x.field.values,
        format: x.field.format
      });
    });

    await Promise.all(promises);
  }


  async calculateFormula(x) {
    try {
      x.values.forEach((key) => {
        this.valueFieldsClon[x.name] = this.valueFieldsClon[x.name].replace(new RegExp(String(key), "g"), (this.valueFieldsClon[key] !== null) ? this.valueFieldsClon[key] : key)
      });
      let calculo = Math.abs(await this.evaluaArimetica(this.valueFieldsClon[x.name]));
      this.formCustomFields.patchValue({
        [x.id]: Number.isFinite(calculo) ? this.formatterValid(calculo, x.format) : '0',
      });
      if (this.formCustomFields.value[x.id] !== undefined)
        this.formCustomFields.controls[x.id].setValidators([!Number.isFinite(calculo) ? forbiddenNameValidator(/ /i) : Validators.required]);

    } catch (error) {
      this.formCustomFields.patchValue({
        [x.id]: '0',
      });
      if (this.formCustomFields.value[x.id] !== undefined) this.formCustomFields.controls[x.id].setValidators([Validators.required, forbiddenNameValidator(/ /i)]);
    }
    if (this.formCustomFields.value[x.id] !== undefined) this.formCustomFields.controls[x.id].updateValueAndValidity();

  }


  setItemSelected(fieldId, id) {
    this.itemSelected[fieldId] = id;
  }
  getItemSelected(fieldId) {
    return this.itemSelected[fieldId] || -1;
  }

  /* INPUT SEARCH DYNAMICALLY WITH SOME FIELDS */
  addData({ field, val }) {
    let id = field.id.toString();
    if (field.type === 18) {
      (<FormArray>this.formCustomFields.get(id)).push(
        this.fb.group({
          value: val,
          tipoMoneda: "",
          montoMulta: "",
          data: {
            adittional_fields: [
              {
                field: "motivo",
                field_name: "Motivo",
                type: "2",
                items: "",
              },
              {
                field: "tipoMoneda",
                field_name: "Tipo de moneda",
                type: "5",
                items: ["UF", "UTM", "IMM"],
              },
              {
                field: "montoMulta",
                field_name: "Monto de multa",
                type: "1",
                items: "",
              },
            ],
          },
        })
      );
    } else {
      (<FormArray>this.formCustomFields.get(id)).push(
        this.fb.group({
          value: val,
        })
      );
    }
    setTimeout(() => {
      this.onChange();
      this.cdr.detectChanges();
    }, 200);
  }

  addInputToArray(fieldId) {
    let id = fieldId.toString();
    (<FormArray>this.formCustomFields.get(id)).push(new FormControl(""));
  }

  addInput({ id, type }) {
    const control = <FormArray>this.formCustomFields.controls[id];
    control.push(this.initInputCollectionType(type, ''));
  }

  initInputCollectionType(type, value) {
    const validations = [];
    if (type === 13) {
      validations.push(correctRutValidator());
    }
    // Agregar validación de email para tipo 15 (dentro de tipo 48)
    if (type === 15) {
      validations.push(validEmailValidator());
    }
    return this.fb.group({
      values: [value, validations]
    });
  }

  removeData({ i, fieldId }) {
    let id = fieldId.toString();
    (<FormArray>this.formCustomFields.get(id)).removeAt(i);
    // Update Form cxustomfield

    this.customfieldsValues.emit(this.formCustomFields);
  }

  /* INPUT SEARCH DYNAMICALLY NORMAL */
  addInputSearch(fieldId) {
    let id = fieldId.toString();
    (<FormArray>this.formCustomFields.get(id)).push(
      this.fb.group({
        valueInput: [],
      })
    );
  }

  removeInputSearch(i, fieldId) {
    let id = fieldId.toString();
    (<FormArray>this.formCustomFields.get(id)).removeAt(i);
    // Update Form Customfield

    this.customfieldsValues.emit(this.formCustomFields);
  }

  removeInput({ i, id }) {
    const control = <FormArray>this.formCustomFields.controls[id];
    control.removeAt(i);
  }

  compareSelectSimpleWithInputText({ o1, o2 }) {
    return JSON.stringify(o1) === JSON.stringify(o2);
  }

  addItemRepeater(field) {
    const itemsRepeater = <FormArray>(
      this.formCustomFields.get(field.id.toString())
    );

    let repeaterField = {};
    for (const iterator of field.values) {
      repeaterField[iterator.field_name] = "";
    }
    itemsRepeater.push(this.fb.group(repeaterField));
  }

  removeItemRepeater({ field, id }) {
    (<FormArray>this.formCustomFields.get(field.id.toString())).removeAt(id);

    this.customfieldsValues.emit(this.formCustomFields);
  }

  findItemSelect(field) {
    const itemSelected = this.formCustomFields.get(field.id.toString())[
      "controls"
    ].select.value;

    const itemFound = field.values.items.find((i) => {
      return i.value == itemSelected;
    });

    this.formCustomFields
      .get(field.id.toString())
    ["controls"].itemName.setValue(itemFound.items[0]);

    this.customfieldsValues.emit(this.formCustomFields);
  }

  rutKeyup(event) {
    const re = new RegExp("[0-9kK]{1}");
    return re.test(event.key) || event.key === "Tab";
  }

  formatRut(rut) {
    if (rut && rut.length > 7) {
      const rev = rut
        .replace(/[\.-]+/g, "")
        .split("")
        .reverse()
        .join("");
      const formated =
        rev.substr(0, 1) +
        "-" +
        rev.substr(1, 3) +
        "." +
        rev.substr(4, 3) +
        "." +
        rev.substr(7, 2);
      formated.split("").reverse().join("");
      rut = formated.split("").reverse().join("");
    }
    return rut;
  }

  formatearRut({ event, key, field }) {
    // Si el campo tiene skipFormatting o noFormat, no formatear
    if (field && (field.skipFormatting || field.noFormat)) {
      // No formatear, solo actualizar el valor sin formato
      if (field.type === 13 || field.type === 12) {
        this.formCustomFields.controls[field.id]["controls"][key].patchValue({
          [field.id]: { values: event.target["value"] }
        });
      } else {
        this.formCustomFields.patchValue({
          [field.id]: event.target["value"]
        });
      }
      this.onChange({ e: event, fields: field });
      return;
    }

    // Formatear normalmente si no tiene la marca de no formatear
    console.log('🟣 Formating RUT:', this.formatRut(event.target["value"]));
    this.onChange({ e: event, fields: field });
    if (field.type === 13 || field.type === 12) {
      this.formCustomFields.controls[field.id]["controls"][key].patchValue({
        [field.id]: { values: this.formatRut(event.target["value"]) }
      });
    } else {
      this.formCustomFields.patchValue({
        [field.id]: this.formatRut(event.target["value"])
      });
    }
  }

  /** Nombres de campos referenciados en `values` de un tipo 45 (fórmula / concatenación). */
  private parseFormulaFieldValues(raw: unknown): string[] {
    if (raw == null || raw === '') {
      return [];
    }
    if (Array.isArray(raw)) {
      return raw
        .map((item) => (typeof item === 'string' ? item.trim() : (item?.name != null ? String(item.name).trim() : '')))
        .filter(Boolean);
    }
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      if (!trimmed) {
        return [];
      }
      if (trimmed.startsWith('[')) {
        try {
          return this.parseFormulaFieldValues(JSON.parse(trimmed));
        } catch {
          return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
        }
      }
      return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
    }
    return [];
  }

  /** Busca definición de customfield por nombre en todas las fuentes disponibles. */
  private findFieldByName(name: string): any {
    if (!name) {
      return undefined;
    }
    const sources = [
      ...(Array.isArray(this.customfieldsAlls) ? this.customfieldsAlls : []),
      ...(Array.isArray(this.fields) ? this.fields : []),
      ...(Array.isArray(this.filterFields) ? this.filterFields : []),
    ];
    return sources.find((f) => f && f.name === name);
  }

  private hasValueFieldsClonKey(key: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.valueFieldsClon, key);
  }

  // field.id,field.value,field.values,field.categoria
  preload(field?) {
    if (!field) {
      return;
    }
    const refs = this.parseFormulaFieldValues(field.values);
    refs.forEach((element) => {
      if (!this.hasValueFieldsClonKey(element)) {
        this.setFormula(element, null);
      }
    });
  }

  formatearCampoCompleted(field?) {
    let valor = null;
    if (!field) {
      return valor;
    }
    if (field.value !== null && field.value !== undefined && field.value !== '') {
      valor = field.format === null ? field.value : this.formatterValid(field.value, field.format);
      if (this.edit) {
        this.preload(field);
      }
    } else if (field.category && field.formula !== null) {
      // type=45 calculado
      this.preload(field);
    } else if (!field.category && field.formula === null) {
      // type=45 concatenado
      const concatenados: string[] = [];
      this.parseFormulaFieldValues(field.values).forEach((element) => {
        const findSearch = this.findFieldByName(element);
        concatenados.push(findSearch?.value ?? '');
      });
      const union = this.joinCampoCompleted(concatenados, '-');
      valor = field.format ? this.formatterValid(union, field.format) : union;
    }
    return valor;
  }

  setFormula(element: string, valor: string | null) {
    if (!element) {
      return;
    }
    let findSearch: { value?: any; formula?: string; name?: string };
    if (valor !== null) {
      findSearch = { value: valor };
      this.valueFieldsClon[element] = valor;
    } else {
      findSearch = this.findFieldByName(element);
      if (!findSearch) {
        console.warn('[customfields] setFormula: campo referenciado no encontrado:', element);
        return;
      }
      this.valueFieldsClon[element] = findSearch.value ?? '';
    }
    if (findSearch.value != null && findSearch.value !== '') {
      const sources = Array.isArray(this.customfieldsAlls) ? this.customfieldsAlls : [];
      sources.forEach((x) => {
        if (x?.formula != null) {
          if (!this.hasValueFieldsClonKey(x.name)) {
            this.valueFieldsClon[x.name] = x.formula;
            const names = this.customfields45.map((el) => el.field.name);
            if (!names.includes(x.name)) {
              this.customfields45.push({ field: x });
            }
          }
        }
      });
    }
  }

  joinCampoCompleted(array, delimitador) {
    return array.join(delimitador);
  }

  currencyFormat(amount) {
    amount = amount.replace(/[\D\s\._\-]+/g, "");
    amount = amount ? parseInt(amount, 10) : 0;
    amount = amount.toLocaleString("es-CL");
    if (amount !== '')
      return '$' + amount;
    return '';
  }

  initCheckboxCollection(values: any) {
    const checkGroup = {};

    if (values) {
      if (typeof values === 'string') {
        values = JSON.parse(values);
      }
      values.map(value => checkGroup[value['name']] = [value['value'] || false, []]);
    }
    return checkGroup;
  }

  onCheckboxChange({ e, index }) {

    let checkArray: FormArray = this.formCustomFields.controls[index] as FormArray;
    if (!checkArray) {
      for (const property in this.formCustomFields.controls) {
        let itemArr = this.formCustomFields.controls[property] as FormArray;
        if (itemArr.hasOwnProperty('controls') && itemArr.controls.length > 0) {
          let itemGr = itemArr.controls[0] as FormGroup;
          checkArray = itemGr.controls[index] as FormArray;
        }
      }
    }
    checkArray.controls.forEach((item: FormGroup) => {
      if (item.value.name == e.target.value) {
        item.controls.value.patchValue(e.target.checked);
        return;
      }
    });
    this.formCustomFields.controls[index] = checkArray;
    this.cleanString('', '', false);
    this.customfieldsValues.emit(this.formCustomFields);
  }

  initInputCollectionTypeM(value: { name: string, value?: boolean }) {
    let obj = { name: value.name, value: (value.value) ? value.value : false }
    return this.fb.group(obj);
  }

  parseSubType(event?) {
    let e = event.e;
    let fields = event.fields;
    let result = fields.values.subtype.data.filter(item => item.items.includes(e.target.value));
    let value = { type: result[0].typeId, subtype: e.target.value };
    this.formCustomFields.controls[fields.id].patchValue(value);
    this.customfieldsValues.emit(this.formCustomFields);
  }

  onCheckRadioChange({ e, index, type }) {
    if (index.name === 'Tipo Plazo') {
      this.getItem22Values({ event: e, name: type })
    } else {
      this.formCustomFields.controls[index.id].patchValue(e);
    }
    this.cleanString('', '', false);

    this.customfieldsValues.emit(this.formCustomFields);
  }

  getItem22Values({ event, name }) {
    switch (name) {
      case 'type':
        this.formCustomFields.controls[this.itemId]["controls"]["type"].patchValue(event);
        this.formCustomFields.controls[this.itemId]["controls"]["condicion"].patchValue(null);
        this.formCustomFields.controls[this.itemId]["controls"]["fecharevision"].patchValue(null);
        this.formCustomFields.controls[this.itemId]["controls"]["fechavencimiento"].patchValue(null);
        this.formCustomFields.controls[this.itemId]["controls"]["avisoterminodias"].patchValue(null);
        this.formCustomFields.controls[this.itemId]["controls"]["periodicidad"].patchValue(null);
        this.formCustomFields.controls[this.itemId]["controls"]["renovacionautomatica"].patchValue(null);
        break;
      case 'condicion':
        this.formCustomFields.controls[this.itemId]["controls"]["condicion"].patchValue(event);
        break;
      case 'fecharevision':
        this.formCustomFields.controls[this.itemId]["controls"]["fecharevision"].patchValue(this.dateformatService.format(event));
        break;
      case 'fechavencimiento':
        this.formCustomFields.controls[this.itemId]["controls"]["fechavencimiento"].patchValue(this.dateformatService.format(event));
        break;
      case 'avisoterminodias':
        this.formCustomFields.controls[this.itemId]["controls"]["avisoterminodias"].patchValue(event);
        break;
      case 'periodicidad':
        this.formCustomFields.controls[this.itemId]["controls"]["periodicidad"].patchValue(event);
        break;
      case 'renovacionautomatica':
        this.formCustomFields.controls[this.itemId]["controls"]["renovacionautomatica"].patchValue(event);
        break;
      default:
        break;
    }
    this.cleanString('', '', false);

    this.customfieldsValues.emit(this.formCustomFields);
  }

  handleFieldDependencies(toggleField: any, toggleValue: boolean) {
    console.log('🟢 handleFieldDependencies CALLED');
    console.log('🟢 Toggle Field:', toggleField);
    console.log('🟢 Toggle Value:', toggleValue);
    console.log('🟢 Field Dependencies:', toggleField.fielddependencies);

    // Procesar dependencias del toggle switch
    if (!toggleField.fielddependencies || typeof toggleField.fielddependencies !== 'object') {
      console.warn('⚠️ No fielddependencies or not an object');
      return;
    }

    // fielddependencies puede tener dos estructuras:
    // 1. Estructura simple (compatibilidad hacia atrás):
    //    { "false": ["fieldName1", "fieldName2"], "true": ["fieldName3", "fieldName4"] }
    // 2. Estructura avanzada (nueva):
    //    { "false": { "disable": [...], "enable": [...], "removeRequired": [...], "removeValidations": [...] }, ... }

    const dependencies = toggleField.fielddependencies;
    console.log('🟢 Dependencies object:', JSON.stringify(dependencies, null, 2));

    const valueKey = toggleValue ? 'true' : 'false';
    const altValueKey = toggleValue ? 'right' : 'left';

    // Obtener la configuración para el valor actual del toggle
    let config = dependencies[valueKey] || dependencies[altValueKey];

    // Si es un array (estructura simple), convertir a estructura avanzada
    if (Array.isArray(config)) {
      config = { disable: config };
    }

    // Si no hay configuración, usar objeto vacío
    if (!config || typeof config !== 'object') {
      config = {};
    }

    console.log('🟢 Config for toggle value:', valueKey, config);

    // Obtener todos los campos disponibles
    let allFields = this.filterFields && this.filterFields.length > 0 ? this.filterFields : this.fields;

    if (this.customfieldsAlls && this.customfieldsAlls.length > 0) {
      const allFieldsFromGroups: any[] = [];
      this.customfieldsAlls.forEach((group: any) => {
        if (group.fields && Array.isArray(group.fields)) {
          allFieldsFromGroups.push(...group.fields);
        }
      });
      allFields = [...(allFields || []), ...allFieldsFromGroups];
    }

    const uniqueFields = Array.from(new Map((allFields || []).map((f: any) => [f.id, f])).values());

    // Función auxiliar para encontrar un campo por nombre
    const findFieldByName = (fieldName: string) => {
      return uniqueFields.find((f: any) =>
        f.name === fieldName || f.alias === fieldName
      );
    };

    // Función auxiliar para aplicar acciones a un campo
    const applyActionsToField = (field: any, actions: string[]) => {
      const control = this.formCustomFields.controls[field.id];
      if (!control) {
        console.warn('⚠️ Control not found for field:', field.name);
        return;
      }

      actions.forEach(action => {
        switch(action) {
          case 'disable':
            console.log('🔴 Disabling field:', field.name);
            control.disable();
            control.setValue(null);
            field.disabled = true;
            field.readonly = true;
            break;
          case 'enable':
            console.log('🟢 Enabling field:', field.name);
            control.enable();
            field.disabled = false;
            field.readonly = false;
            break;
          case 'removeRequired':
            console.log('🔴 Removing required validation from field:', field.name);
            const currentValidators = control.validator ? [control.validator] : [];
            const newValidators = currentValidators.filter((v: any) => {
              // Remover Validators.required
              return v !== Validators.required;
            });
            control.setValidators(newValidators.length > 0 ? newValidators : null);
            control.updateValueAndValidity();
            field.required = false;
            break;
          case 'addRequired':
            console.log('🟢 Adding required validation to field:', field.name);
            const currentValidatorsReq = control.validator ? [control.validator] : [];
            if (!currentValidatorsReq.includes(Validators.required)) {
              currentValidatorsReq.push(Validators.required);
            }
            control.setValidators(currentValidatorsReq);
            control.updateValueAndValidity();
            field.required = true;
            break;
          case 'removeValidations':
            console.log('🔴 Removing all validations from field:', field.name);
            // Guardar el valor actual antes de limpiar
            const currentValue = control.value;
            // Remover TODAS las validaciones
            control.clearValidators();
            // Limpiar TODOS los errores de manera forzada
            control.setErrors(null);
            // Marcar el campo como válido y limpio (esto es crítico para que no muestre errores visuales)
            control.markAsPristine();
            control.markAsUntouched();
            // Marcar el campo para que NO se formatee (importante para campos tipo 8 RUT)
            field.skipFormatting = true;
            field.noFormat = true;
            // Restaurar el valor (si había uno) sin validaciones y sin formato
            if (currentValue !== null && currentValue !== undefined) {
              // Si es un RUT formateado, quitar el formato
              let unformattedValue = currentValue;
              if (field.type === 8 && typeof currentValue === 'string') {
                // Quitar puntos y guiones del RUT
                unformattedValue = currentValue.replace(/[\.-]+/g, '');
                console.log('🔴 Removed RUT formatting. Original:', currentValue, 'Unformatted:', unformattedValue);
              }
              // Actualizar el valor sin formato inmediatamente
              control.setValue(unformattedValue, { emitEvent: false, onlySelf: true });
              // Forzar actualización del input HTML directamente
              setTimeout(() => {
                // Actualizar el valor nuevamente para asegurar que se refleje
                control.setValue(unformattedValue, { emitEvent: false, onlySelf: true });
                // Buscar el input HTML y actualizarlo directamente si es necesario
                const inputElement = document.querySelector(`input[formControlName="${field.id}"]`) as HTMLInputElement;
                if (inputElement && inputElement.value !== unformattedValue) {
                  inputElement.value = unformattedValue;
                  console.log('🔴 Updated input HTML directly:', unformattedValue);
                }
                this.cdr.detectChanges();
              }, 0);
            }
            // Actualizar el estado de validación sin emitir eventos
            control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
            // Forzar limpieza adicional de errores después de actualizar (en el siguiente ciclo)
            setTimeout(() => {
              // Limpiar errores nuevamente por si acaso
              if (control.errors) {
                control.setErrors(null);
              }
              // Asegurar que el campo esté marcado como válido y limpio
              control.markAsPristine();
              control.markAsUntouched();
              control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
              // Forzar detección de cambios para actualizar la vista
              this.cdr.detectChanges();
            }, 0);
            // También forzar detección de cambios inmediatamente
            this.cdr.detectChanges();
            break;
          case 'addValidations':
            console.log('🟢 Adding validations to field:', field.name);
            // Quitar la marca de no formatear para restaurar el formato
            field.skipFormatting = false;
            field.noFormat = false;
            // Agregar validaciones según el tipo de campo
            const validatorsToAdd: any[] = [];
            if (field.required) {
              validatorsToAdd.push(Validators.required);
            }
            // Si es tipo 8 (RUT), agregar validación de RUT
            if (field.type === 8) {
              validatorsToAdd.push(correctRutValidator());
            }
            // Si es tipo 15 (Email), agregar validación de email
            if (field.type === 15) {
              validatorsToAdd.push(Validators.email);
            }
            // Si tiene expresión regular, agregarla
            if (field.regularexpression) {
              validatorsToAdd.push(Validators.pattern(field.regularexpression));
            }
            control.setValidators(validatorsToAdd.length > 0 ? validatorsToAdd : null);
            control.updateValueAndValidity();
            break;
        }
      });
    };

    // Procesar cada acción en la configuración
    Object.keys(config).forEach(action => {
      const fieldNames = config[action];
      if (Array.isArray(fieldNames) && fieldNames.length > 0) {
        console.log(`🟡 Processing action "${action}" for fields:`, fieldNames);
        fieldNames.forEach((fieldName: string) => {
          const field = findFieldByName(fieldName);
          if (field) {
            applyActionsToField(field, [action]);
          } else {
            console.warn('⚠️ Field not found for action:', action, 'Field name:', fieldName);
          }
        });
      }
    });

    // También procesar la configuración opuesta para revertir acciones
    const oppositeKey = toggleValue ? 'false' : 'true';
    const oppositeAltKey = toggleValue ? 'left' : 'right';
    let oppositeConfig = dependencies[oppositeKey] || dependencies[oppositeAltKey];

    if (Array.isArray(oppositeConfig)) {
      oppositeConfig = { enable: oppositeConfig };
    }

    if (oppositeConfig && typeof oppositeConfig === 'object') {
      console.log('🟡 Processing opposite config for toggle value:', oppositeKey);
      Object.keys(oppositeConfig).forEach(action => {
        const fieldNames = oppositeConfig[action];
        if (Array.isArray(fieldNames) && fieldNames.length > 0) {
          // Invertir las acciones para la configuración opuesta
          const invertedAction = action === 'disable' ? 'enable' :
                                action === 'enable' ? 'disable' :
                                action === 'removeRequired' ? 'addRequired' :
                                action === 'addRequired' ? 'removeRequired' :
                                action === 'removeValidations' ? 'addValidations' :
                                action === 'addValidations' ? 'removeValidations' : action;

          fieldNames.forEach((fieldName: string) => {
            const field = findFieldByName(fieldName);
            if (field) {
              applyActionsToField(field, [invertedAction]);
            }
          });
        }
      });
    }

    console.log('🟢 Finished processing dependencies');

    // Forzar detección de cambios para actualizar la vista
    this.cdr.detectChanges();
  }


}
